<template>
  <div class="inner-container" :class="{ 'min-container': !getTabs }">
    <div class="page-header">
      <h1>{{ dossierDetail ? dossierDetail.name :  "Détail du dossier" }}</h1>
      <b-button
        size="sm"
        class="ml-2 float-right mb-2 btn-back-dossier"
        @click="$router.push({ name: 'GestionDossiers' })"
      >
        <font-awesome-icon icon="arrow-left" /> {{  "Retour" }}
      </b-button>
    </div>

    <div class="content">
      <b-spinner v-if="loading" variant="primary" class="d-block mx-auto my-5"></b-spinner>

      <template v-else-if="dossierDetail">
        <div class="modal-test">
          <div>
            <div class="cours">
              <!-- Affichage des pipelines et sous-pipelines en badges -->
              <div class="pipeline-badges" v-if="dossierDetail.pipelines && dossierDetail.pipelines.length">
                <span 
                  v-for="pipeline in dossierDetail.pipelines" 
                  :key="pipeline.id || pipeline.name"
                  class="pipeline-badge"
                  :class="getPipelineBadgeClass(pipeline)"
                  :title="pipeline.description || pipeline.name"
                >
                  {{ pipeline.name || pipeline.label }}
                </span>
              </div>
              <div class="sous-pipeline-badges" v-if="dossierDetail.sous_pipelines && dossierDetail.sous_pipelines.length">
                <span 
                  v-for="sousPipeline in dossierDetail.sous_pipelines" 
                  :key="sousPipeline.id || sousPipeline.name"
                  class="sous-pipeline-badge"
                  :class="getSousPipelineBadgeClass(sousPipeline)"
                  :title="sousPipeline.description || sousPipeline.name"
                >
                  {{ sousPipeline.name || sousPipeline.label }}
                </span>
              </div>
              <!-- Fallback: afficher le statut si aucun pipeline -->
              
            </div>
          
          </div>

          <b-tabs content-class="mt-3 tabs" justified>
            <!-- Onglet Info client -->
            <b-tab :title="'Info client'" active lazy>
              <!-- Informations client -->
              <div class="info-client-grid">
               <div class="part justify info-client-col">
                  <div class="info-card">
                    <div class="divborder d-flex align-items-center justify-content-between flex-wrap">
                      <p>{{ "Détail du dossier" }}</p>
                    </div>
                    <div class="left">
                      <ul>
                        <li>
                          <span class="title">Nom du dossier:</span>
                          <span class="textstyle">{{ dossierDetail.name || "-" }}</span>
                        </li>
                        <li v-if="dossierDetail.numero_dossier">
                          <span class="title">N° dossier:</span>
                          <span class="textstyle">{{ dossierDetail.numero_dossier }}</span>
                        </li>
                        <li v-if="dossierDetail.pipelines && dossierDetail.pipelines.length">
                          <span class="title">Pipeline :</span>
                          <div class="pipeline-badges-inline">
                            <span 
                              v-for="pipeline in dossierDetail.pipelines" 
                              :key="pipeline.id || pipeline.name"
                              class="pipeline-badge-small"
                              :class="getPipelineBadgeClass(pipeline)"
                              :title="pipeline.description || pipeline.name"
                            >
                              {{ pipeline.name || pipeline.label }}
                            </span>
                          </div>
                        </li>
                        <li v-if="dossierDetail.sous_pipelines && dossierDetail.sous_pipelines.length">
                          <span class="title">{{ $t("SOUS_PIPELINE") || "Sous-pipeline" }}:</span>
                          <div class="sous-pipeline-badges-inline">
                            <span 
                              v-for="sousPipeline in dossierDetail.sous_pipelines" 
                              :key="sousPipeline.id || sousPipeline.name"
                              class="sous-pipeline-badge-small"
                              :class="getSousPipelineBadgeClass(sousPipeline)"
                              :title="sousPipeline.description || sousPipeline.name"
                            >
                              {{ sousPipeline.name || sousPipeline.label }}
                            </span>
                          </div>
                        </li>
                        <li v-if="(!dossierDetail.pipelines || !dossierDetail.pipelines.length) && (!dossierDetail.sous_pipelines || !dossierDetail.sous_pipelines.length) && dossierDetail.status">
                          <span class="title">{{ $t("STATUS") || "Statut" }}:</span>
                          <span class="textstyle">{{ getStatusLabel(dossierDetail.status) }}</span>
                        </li>
                        <li v-if="dossierDetail.created_at">
                          <span class="title">{{ $t("DATE") || "Date" }}:</span>
                          <span class="textstyle">{{ moment(dossierDetail.created_at).format("DD-MM-YYYY") }}</span>
                        </li>
                        <li v-if="dossierDetail.updated_at">
                          <span class="title">{{ $t("UPDATED_AT") || "Dernière mise à jour" }}:</span>
                          <span class="textstyle">{{ moment(dossierDetail.updated_at).format("DD-MM-YYYY") }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="part justify info-client-col">
                  <div class="info-card">
                    <div class="divborder d-flex align-items-center justify-content-between flex-wrap">
                      <p>{{  "Info client" }}</p>
                    </div>
                    <div class="left" v-if="dossierDetail.client">
                      <ul>
                      <li v-if="dossierDetail.client.num_client">
                        <span class="title">{{  "N° client" }}:</span>
                        <span class="textstyle">{{ dossierDetail.client.num_client }}</span>
                      </li>
                      <li>
                        <span class="title">{{  "Civilité" }} / {{ "Nom" }}:</span>
                        <span class="textstyle">{{ [dossierDetail.client.civilite, dossierDetail.client.prenom, dossierDetail.client.nom].filter(Boolean).join(" ") || "-" }}</span>
                      </li>
                      <li v-if="dossierDetail.client.signataire_nom || dossierDetail.client.signataire_prenom">
                        <span class="title">{{ "Signataire" }}:</span>
                        <span class="textstyle">{{ [dossierDetail.client.signataire_prenom, dossierDetail.client.signataire_nom].filter(Boolean).join(" ") || "-" }}</span>
                      </li>
                      <li v-if="dossierDetail.client.type">
                        <span class="title">{{ $t("TYPE") }}:</span>
                        <span class="textstyle">{{ formatClientType(dossierDetail.client.type) }}</span>
                      </li>
                      <li v-if="dossierDetail.client.type_occupation">
                        <span class="title">{{  "Type d'occupation" }}:</span>
                        <span class="textstyle">{{ dossierDetail.client.type_occupation }}</span>
                      </li>
                      <li v-if="dossierDetail.client.email">
                        <span class="title">{{ $t("EMAIL") || "Email" }}:</span>
                        <span class="textstyle">{{ dossierDetail.client.email }}</span>
                      </li>
                      <li v-if="dossierDetail.client.phone || dossierDetail.client.tel">
                        <span class="title">{{ $t("PHONE") || "Téléphone" }}:</span>
                        <span class="textstyle">{{ (dossierDetail.client.phone && dossierDetail.client.phone.formated_phone) || dossierDetail.client.tel || dossierDetail.client.telephone || "-" }}</span>
                      </li>
                      <li v-if="dossierDetail.client.siret">
                        <span class="title">{{ $t("SIRET") || "SIRET" }}:</span>
                        <span class="textstyle">{{ dossierDetail.client.siret }}</span>
                      </li>
                      <li v-if="dossierDetail.client.rue || dossierDetail.client.ville || dossierDetail.client.adresse">
                        <span class="title">{{ $t("ADDRESS") || "Adresse" }}:</span>
                        <span class="textstyle">{{ formatAdresse(dossierDetail.client) }}</span>
                      </li>
                      <li v-if="dossierDetail.client.zone">
                        <span class="title">{{ $t("ZONE") || "Zone" }}:</span>
                        <span class="textstyle">{{ dossierDetail.client.zone }}</span>
                      </li>
                      <li v-if="dossierDetail.client.precarite">
                        <span class="title">{{ $t("PRECARITE") || "Précarité" }}:</span>
                        <span class="textstyle">{{ dossierDetail.client.precarite }}</span>
                      </li>
                      </ul>
                    </div>
                    <div class="left" v-else>
                      <p class="text-muted">{{ $t("NO_CLIENT_DATA") || "Aucune donnée client." }}</p>
                    </div>
                  </div>
                </div>
               
              </div>
            </b-tab>

            <!-- Onglet Document -->
            <b-tab :title="$t('DOCUMENT')" lazy>
              <div class="part justify">
                <div class="divborder">
                  <p>{{ $t("DOCUMENT") }}</p>
                </div>
                <div class="document-create-buttons d-flex gap-2 flex-wrap mt-2">
                  <b-dropdown
                    size="sm"
                    variant="success"
                    class="text-white"
                    :disabled="isDossierLocked"
                    no-caret
                  >
                    <template #button-content>
                      <font-awesome-icon icon="plus-circle" class="mr-1" />
                      {{ "Devis" }}
                    </template>
                    <b-dropdown-item @click="goToCreateDevis">
                      {{ "Créer nouveau devis" }}
                    </b-dropdown-item>
                    <b-dropdown-item @click="goToDevisExistant">
                      {{  "Devis existant" }}
                    </b-dropdown-item>
                  </b-dropdown>
                  <b-dropdown
                    size="sm"
                    variant="success"
                    class="text-white"
                    :disabled="isDossierLocked"
                    no-caret
                  >
                    <template #button-content>
                      <font-awesome-icon icon="plus-circle" class="mr-1" />
                      {{ $t("FACTURE") || "Facture" }}
                    </template>
                    <b-dropdown-item @click="goToCreateFacture">
                      {{ "Créer nouvelle facture" }}
                    </b-dropdown-item>
                    <b-dropdown-item @click="goToFactureExistant">
                      {{  "Facture existante" }}
                    </b-dropdown-item>
                  </b-dropdown>
                  <b-dropdown
                    size="sm"
                    variant="success"
                    class="text-white"
                    :disabled="isDossierLocked"
                    no-caret
                  >
                    <template #button-content>
                      <font-awesome-icon icon="plus-circle" class="mr-1" />
                      {{ $t("CC") || "CC" }}
                    </template>
                    <b-dropdown-item @click="goToCreateCEE">
                      {{ "Créer nouveau CC" }}
                    </b-dropdown-item>
                    <b-dropdown-item @click="goToCEEExistant">
                      {{ "CC existant" }}
                    </b-dropdown-item>
                  </b-dropdown>
                  <b-dropdown
                    size="sm"
                    variant="success"
                    class="text-white"
                    :disabled="isDossierLocked"
                    no-caret
                  >
                    <template #button-content>
                      <font-awesome-icon icon="plus-circle" class="mr-1" />
                      {{ $t("AH") || "AH" }}
                    </template>
                    <b-dropdown-item @click="goToCreateAH">
                      {{ "Créer nouveau AH" }}
                    </b-dropdown-item>
                    <b-dropdown-item @click="goToAHExistant">
                      {{ "AH existant" }}
                    </b-dropdown-item>
                  </b-dropdown>
                  <b-button
                    size="sm"
                    variant="info"
                    class="text-white"
                    :disabled="isDossierLocked"
                    @click="openImportDocumentModal"
                  >
                    <font-awesome-icon icon="file-import" class="mr-1" />
                    {{  "Importer" }} {{  "des documents" }}
                  </b-button>
                </div>
              </div>
              <div class="document-filters mb-3 d-flex align-items-center flex-wrap" v-if="!documentLoading && documentRows.length">
                <b-form-input
                  v-model="documentSearch"
                  size="sm"
                  class="doc-filter-search"
                  :placeholder="$t('SEARCH') || 'Rechercher...'"
                  style="max-width: 220px; display: inline-block;"
                  @input="onDocumentSearchInput"
                />
                <multiselect
                  v-model="documentFilterCategories"
                  :options="documentCategoryFilterOptions"
                  :placeholder=" 'Filtrer par catégorie'"
                  size="sm"
                  class="doc-filter-select ml-2"
                  style="max-width: 200px; display: inline-block;"
                  label="label"
                  track-by="id"
                  :searchable="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :loading="getDocumentCategoriesLoading"
                  :internal-search="false"
                  :options-limit="10"
                  :limit="1"
                  :max-height="200"
                  :show-no-results="false"
                  :hide-selected="false"
                  :multiple="false"
                  :allow-empty="true"
                  @input="onDocumentCategoryFilterChange"
                >
                  <template #noResult>
                    {{  'Aucun résultat trouvé' }}
                  </template>
                  <template #noOptions>
                    {{ 'Aucune catégorie disponible' }}
                  </template>
                </multiselect>
                <b-button
                  v-if="selectedDocumentIndices.length > 0"
                  size="sm"
                  variant="primary"
                  class="ml-2 text-white"
                  :disabled="documentExportLoading"
                  @click="exportSelectedDocuments"
                >
                  <b-spinner v-if="documentExportLoading" small class="mr-1"></b-spinner>
                  <font-awesome-icon v-else icon="file-export" class="mr-1" />
                  {{  "Exporter la sélection" }} ({{ selectedDocumentIndices.length }})
                </b-button>
              </div>
              <b-spinner v-if="documentLoading" class="d-block mx-auto my-3" small></b-spinner>
              <div v-else class="table-rapport-style w-100 doc-table-wrap">
                <table class="doc-table">
                  <thead>
                    <tr>
                    <!--  <th style="width: 40px; border-radius: 5px 0 0 0">
                        <b-form-checkbox
                          :checked="filteredDocumentRows.length > 0 && filteredDocumentRows.every((item) => selectedDocumentIndices.includes(item.index))"
                          :indeterminate="filteredDocumentRows.some((item) => selectedDocumentIndices.includes(item.index)) && !filteredDocumentRows.every((item) => selectedDocumentIndices.includes(item.index))"
                          @change="toggleSelectAllFilteredDocuments"
                        />
                      </th>-->
                      <th>{{ $t("TYPE") || "Type" }}</th>
                      <th>{{ $t("NUMERO") || "N°" }}</th>
                      <th>{{ $t("DATE") || "Date" }}</th>
                      <th>{{ $t("OPERATION") || "Opération" }}</th>
                      <th>{{ $t("DOWNLOAD") || "Téléchargement" }}</th>
                      <th>{{ $t("ACTION") || "Action" }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in filteredDocumentRows"
                      :key="(item.doc.typeId || item.index) + '-' + item.index"
                      role="row"
                      class="ligneNormale"
                    >
                        <!-- <td class="doc-check-cell" @click.stop>
                          <b-form-checkbox
                            :checked="selectedDocumentIndices.includes(item.index)"
                            @change="toggleDocumentSelection(item.index)"
                          />
                        </td>-->
                      <td>{{ item.doc.typeLabel }}
                        <span v-if="item.doc.category && item.doc.downloadType !== 'complementaire'" class="badge badge-primary ml-2">
                          {{ item.doc.category.label }}
                        </span>
                      </td>
                      <td>{{ item.doc.numero || "-" }}</td>
                      <td>{{ formatDocumentDate(item.doc.date) }}</td>
                      <td>
                        <span v-if="item.doc.raw && item.doc.raw.type_devis" class="badge badge-info">
                          {{ item.doc.raw.type_devis }}
                        </span>
                        <span v-else-if="item.doc.downloadType === 'devis' && item.doc.raw && item.doc.raw.type" class="badge badge-info">
                          {{ item.doc.raw.type }}
                        </span>
                        <span v-else class="text-muted">-</span>
                      </td>
                      <td>
                        <div class="grey">
                          <b-spinner v-if="fileLoading[item.index] || documentPdfLoadingId === item.doc.downloadId + '-' + (item.doc.downloadType || '')" label="Spinning" small></b-spinner>
                          <font-awesome-icon
                            v-else-if="item.doc.downloadType === 'complementaire' && item.doc.pdfPath"
                            icon="download"
                            class="download-icon mr-2"
                            @click="downloadComplementairePdf(item.doc)"
                          />
                          <font-awesome-icon
                            v-else-if="item.doc.downloadType === 'devis' || item.doc.downloadType === 'facture' || item.doc.downloadType === 'ah' || item.doc.downloadType === 'cee' || item.doc.downloadType === 'cc'"
                            icon="download"
                            class="download-icon mr-2"
                            @click="downloadDocumentPdf(item.doc)"
                          />
                          <font-awesome-icon
                            v-else-if="item.doc.file"
                            icon="download"
                            class="download-icon mr-2"
                            @click="downloadFile(item.doc.raw, item.index)"
                          />
                          <font-awesome-icon v-else icon="times" />
                        </div>
                      </td>
                      <td>
                        <span v-if="item.doc.downloadType === 'devis'">
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            class="mr-1"
                            @click.stop="openDocumentView(item.doc)"
                            :title="$t('VIEW') || 'Voir'"
                          >
                            <font-awesome-icon icon="eye" />
                          </b-button>
                          <b-button
                            size="sm"
                            variant="outline-primary"
                            class="mr-1"
                            :disabled="isDossierLocked"
                            @click.stop="editDocument(item.doc)"
                            :title="$t('EDIT') || 'Modifier'"
                          >
                            <font-awesome-icon icon="edit" />
                          </b-button>
                          <b-button
                            size="sm"
                            variant="outline-danger"
                            class="mr-1"
                            :disabled="isDossierLocked"
                            @click.stop="confirmDeleteDocument(item.doc)"
                            :title="$t('DELETE') || 'Supprimer'"
                          >
                            <font-awesome-icon icon="trash" />
                          </b-button>
                          <b-button
                            size="sm"
                            variant="outline-warning"
                            :disabled="isDossierLocked"
                            @click.stop="confirmDissociateDocument(item.doc)"
                            :title="$t('DISSOCIATE') || 'Dissocier'"
                          >
                            <font-awesome-icon icon="unlink" />
                          </b-button>
                        </span>
                        <span v-else-if="item.doc.downloadType === 'facture'">
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            class="mr-1"
                            @click.stop="openDocumentView(item.doc)"
                            :title="$t('VIEW') || 'Voir'"
                          >
                            <font-awesome-icon icon="eye" />
                          </b-button>
                          <b-button
                            size="sm"
                            variant="outline-primary"
                            class="mr-1"
                            :disabled="isDossierLocked"
                            @click.stop="editDocument(item.doc)"
                            :title="$t('EDIT') || 'Modifier'"
                          >
                            <font-awesome-icon icon="edit" />
                          </b-button>
                          <b-button
                            size="sm"
                            variant="outline-danger"
                            class="mr-1"
                            :disabled="isDossierLocked"
                            @click.stop="confirmDeleteDocument(item.doc)"
                            :title="$t('DELETE') || 'Supprimer'"
                          >
                            <font-awesome-icon icon="trash" />
                          </b-button>
                          <b-button
                            size="sm"
                            variant="outline-warning"
                            :disabled="isDossierLocked"
                            @click.stop="confirmDissociateDocument(item.doc)"
                            :title="$t('DISSOCIATE') || 'Dissocier'"
                          >
                            <font-awesome-icon icon="unlink" />
                          </b-button>
                        </span>
                        <span v-else-if="item.doc.downloadType === 'ah' || item.doc.downloadType === 'cee' || item.doc.downloadType === 'cc'">
                          <b-button
                            size="sm"
                            variant="outline-danger"
                            class="mr-1"
                            :disabled="isDossierLocked"
                            @click.stop="confirmDeleteDocument(item.doc)"
                            :title="$t('DELETE') || 'Supprimer'"
                          >
                            <font-awesome-icon icon="trash" />
                          </b-button>
                          <b-button
                            size="sm"
                            variant="outline-warning"
                            :disabled="isDossierLocked"
                            @click.stop="confirmDissociateDocument(item.doc)"
                            :title="$t('DISSOCIATE') || 'Dissocier'"
                          >
                            <font-awesome-icon icon="unlink" />
                          </b-button>
                        </span>
                        <span v-else-if="item.doc.downloadType === 'complementaire'">
                          <b-button
                            size="sm"
                            variant="outline-danger"
                            :disabled="isDossierLocked"
                            @click.stop="confirmDeleteDocument(item.doc)"
                            :title="$t('DELETE') || 'Supprimer'"
                          >
                            <font-awesome-icon icon="trash" />
                          </b-button>
                        </span>
                        <span v-else>-</span>
                      </td>
                    </tr>
                    <tr v-if="!documentRows.length && !loading">
                      <td colspan="6" class="text-center text-muted py-4">{{ $t("NO_DOCUMENT") || "Aucun document." }}</td>
                    </tr>
                    <tr v-else-if="documentRows.length && !filteredDocumentRows.length">
                      <td colspan="6" class="text-center text-muted py-4">{{ $t("NO_RESULT") || "Aucun résultat pour les filtres." }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Modal Import complémentaires PDF -->
              <b-modal
                id="importDocumentModal"
                ref="importDocumentModal"
                :title=" 'Importer des documents'"
                hide-footer
                @hidden="resetImportDocumentModal"
              >
               
                <b-form class="bg-white p-3" @submit.prevent="submitImportComplementaires">
                  <b-form-group :label=" 'Fichiers PDF'">
                    <b-form-file
                      v-model="importComplementairesFiles"
                      accept=".pdf,application/pdf"
                      multiple
                      :placeholder=" 'Choisir des fichiers'"
                      drop-placeholder="Déposer les PDF ici"
                    />
                  </b-form-group>
                  <b-form-group :label=" 'Catégorie (optionnel)'">
                    <multiselect
                      v-model="importComplementairesCategory"
                      :options="getDocumentCategories || []"
                      :placeholder=" 'Sélectionner une catégorie'"
                      label="label"
                      track-by="id"
                      :searchable="true"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :loading="getDocumentCategoriesLoading"
                      :internal-search="false"
                      :options-limit="10"
                      :limit="1"
                      :max-height="200"
                      :show-no-results="false"
                      :hide-selected="true"
                      :multiple="false"
                    >
                      <template #noResult>
                        {{  'Aucun résultat trouvé' }}
                      </template>
                      <template #noOptions>
                        {{  'Aucune catégorie disponible' }}
                      </template>
                    </multiselect>
                  </b-form-group>
                  <div class="d-flex justify-content-end mt-3">
                    <b-button variant="secondary" class="mr-2" @click="$refs.importDocumentModal.hide()">
                      {{ $t("CANCEL") || "Annuler" }}
                    </b-button>
                    <b-button variant="success" type="submit" :disabled="documentImportSaving || !dossierDocument?.id || !hasImportComplementairesFiles">
                      <b-spinner v-if="documentImportSaving" small class="mr-1"></b-spinner>
                      {{  "Importer" }}
                    </b-button>
                  </div>
                </b-form>
              </b-modal>

              <!-- Modal Associer Devis existant -->
              <b-modal
                id="associateDevisModal"
                ref="associateDevisModal"
                title="Associer un devis existant"
                size="lg"
                hide-footer
                @hidden="resetAssociateDevisModal"
              >
                <div class="mb-3">
                  <b-form-input
                    v-model="associateDevisModal.search"
                    placeholder="Rechercher par numéro ou nom..."
                    size="sm"
                  />
                </div>
                <div v-if="associateDevisModal.loading" class="text-center py-4">
                  <b-spinner small></b-spinner>
                  <span class="ml-2">Chargement des devis...</span>
                </div>
                <div v-else-if="!filteredAssociateDevisList.length" class="text-center text-muted py-4">
                  Aucun devis disponible pour ce client.
                </div>
                <div v-else class="table-responsive associate-modal-table">
                  <table class="table table-sm table-hover">
                    <thead class="thead-light">
                      <tr>
                        <th style="width: 40px;">
                          <b-form-checkbox
                            :checked="associateDevisModal.selected.length === filteredAssociateDevisList.length && filteredAssociateDevisList.length > 0"
                            :indeterminate="associateDevisModal.selected.length > 0 && associateDevisModal.selected.length < filteredAssociateDevisList.length"
                            @change="toggleSelectAllAssociateDevis"
                          />
                        </th>
                        <th>N° Devis</th>
                        <!--<th>N° Facture</th>-->
                        <!--<th>Client</th>-->
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="devis in filteredAssociateDevisList" :key="devis.id">
                        <td>
                          <b-form-checkbox
                            :checked="associateDevisModal.selected.includes(getDevisId(devis))"
                            @change="toggleAssociateDevisSelection(getDevisId(devis))"
                          />
                        </td>
                        <td>{{ devis.devis.numerodevis ||  devis.id }}</td>
                       <!-- <td>
                          <span v-if="devis.numerofacture" class="badge badge-info">{{ devis.numerofacture }}</span>
                          <span v-else class="text-muted">-</span>
                        </td>-->
                       <!-- <td>{{ devis.client ? [devis.client.prenom, devis.client.nom].filter(Boolean).join(' ') : '-' }}</td>-->
                        <td>{{ formatCommentDate(devis.created_at) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <b-alert v-if="hasDevisWithFacture" show variant="warning" class="mt-3 mb-0">
                  <font-awesome-icon icon="exclamation-triangle" class="mr-1" />
                  <strong>Attention :</strong> Certains devis sélectionnés ont une facture associée. Ces factures seront également associées au dossier.
                </b-alert>
                <div class="d-flex justify-content-between align-items-center mt-3">
                  <span class="text-muted">{{ associateDevisModal.selected.length }} devis sélectionné(s)</span>
                  <div>
                    <b-button variant="secondary" class="mr-2" @click="$refs.associateDevisModal.hide()">
                      Annuler
                    </b-button>
                    <b-button
                      variant="primary"
                      :disabled="!associateDevisModal.selected.length || associateDevisModal.saving"
                      @click="submitAssociateDevis"
                    >
                      <b-spinner v-if="associateDevisModal.saving" small class="mr-1"></b-spinner>
                      Associer
                    </b-button>
                  </div>
                </div>
              </b-modal>

              <!-- Modal Associer CEE existant -->
              <b-modal
                id="associateCEEModal"
                ref="associateCEEModal"
                title="Associer un CC existant"
                size="lg"
                hide-footer
                @hidden="resetAssociateCEEModal"
              >
                <div class="mb-3">
                  <b-form-input
                    v-model="associateCEEModal.search"
                    placeholder="Rechercher par numéro ou nom..."
                    size="sm"
                  />
                </div>
                <div v-if="associateCEEModal.loading" class="text-center py-4">
                  <b-spinner small></b-spinner>
                  <span class="ml-2">Chargement des CC...</span>
                </div>
                <div v-else-if="!filteredAssociateCEEList.length" class="text-center text-muted py-4">
                  Aucun CC disponible pour ce client.
                </div>
                <div v-else class="table-responsive associate-modal-table">
                  <table class="table table-sm table-hover">
                    <thead class="thead-light">
                      <tr>
                        <th style="width: 40px;">
                          <b-form-checkbox
                            :checked="associateCEEModal.selected.length === filteredAssociateCEEList.length && filteredAssociateCEEList.length > 0"
                            :indeterminate="associateCEEModal.selected.length > 0 && associateCEEModal.selected.length < filteredAssociateCEEList.length"
                            @change="toggleSelectAllAssociateCEE"
                          />
                        </th>
                        <th>N° CC</th>
                        <th>Client</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="cee in filteredAssociateCEEList" :key="cee.id">
                        <td>
                          <b-form-checkbox
                            :checked="associateCEEModal.selected.includes(cee.id)"
                            @change="toggleAssociateCEESelection(cee.id)"
                          />
                        </td>
                        <td>{{ cee.numero_sequence || cee.id }}</td>
                        <td>{{ cee.client ? [cee.client.prenom, cee.client.nom].filter(Boolean).join(' ') : '-' }}</td>
                        <td>{{ formatCommentDate(cee.created_at) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-3">
                  <span class="text-muted">{{ associateCEEModal.selected.length }} CC sélectionné(s)</span>
                  <div>
                    <b-button variant="secondary" class="mr-2" @click="$refs.associateCEEModal.hide()">
                      Annuler
                    </b-button>
                    <b-button
                      variant="primary"
                      :disabled="!associateCEEModal.selected.length || associateCEEModal.saving"
                      @click="submitAssociateCEE"
                    >
                      <b-spinner v-if="associateCEEModal.saving" small class="mr-1"></b-spinner>
                      Associer
                    </b-button>
                  </div>
                </div>
              </b-modal>

              <!-- Modal Associer AH existant -->
              <b-modal
                id="associateAHModal"
                ref="associateAHModal"
                title="Associer un AH existant"
                size="lg"
                hide-footer
                @hidden="resetAssociateAHModal"
              >
                <div class="mb-3">
                  <b-form-input
                    v-model="associateAHModal.search"
                    placeholder="Rechercher par numéro ou nom..."
                    size="sm"
                  />
                </div>
                <div v-if="associateAHModal.loading" class="text-center py-4">
                  <b-spinner small></b-spinner>
                  <span class="ml-2">Chargement des AH...</span>
                </div>
                <div v-else-if="!filteredAssociateAHList.length" class="text-center text-muted py-4">
                  Aucun AH disponible pour ce client.
                </div>
                <div v-else class="table-responsive associate-modal-table">
                  <table class="table table-sm table-hover">
                    <thead class="thead-light">
                      <tr>
                        <th style="width: 40px;">
                          <b-form-checkbox
                            :checked="associateAHModal.selected.length === filteredAssociateAHList.length && filteredAssociateAHList.length > 0"
                            :indeterminate="associateAHModal.selected.length > 0 && associateAHModal.selected.length < filteredAssociateAHList.length"
                            @change="toggleSelectAllAssociateAH"
                          />
                        </th>
                        <th>N° AH</th>
                       <!-- <th>Client</th>-->
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="ah in filteredAssociateAHList" :key="ah.id">
                        <td>
                          <b-form-checkbox
                            :checked="associateAHModal.selected.includes(ah.id)"
                            @change="toggleAssociateAHSelection(ah.id)"
                          />
                        </td>
                        <td>{{ ah.numero_sequence || ah.numero || ah.id }}</td>
                       <!-- <td>{{ (ah.devis && ah.devis.client) || ah.client ? [((ah.devis && ah.devis.client) || ah.client).prenom, ((ah.devis && ah.devis.client) || ah.client).nom].filter(Boolean).join(' ') : '-' }}</td>-->
                        <td>{{ formatCommentDate(ah.created_at) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-3">
                  <span class="text-muted">{{ associateAHModal.selected.length }} AH sélectionné(s)</span>
                  <div>
                    <b-button variant="secondary" class="mr-2" @click="$refs.associateAHModal.hide()">
                      Annuler
                    </b-button>
                    <b-button
                      variant="primary"
                      :disabled="!associateAHModal.selected.length || associateAHModal.saving"
                      @click="submitAssociateAH"
                    >
                      <b-spinner v-if="associateAHModal.saving" small class="mr-1"></b-spinner>
                      Associer
                    </b-button>
                  </div>
                </div>
              </b-modal>

              <!-- Modal Associer Facture existante -->
              <b-modal
                id="associateFactureModal"
                ref="associateFactureModal"
                title="Associer une facture existante"
                size="lg"
                hide-footer
                @hidden="resetAssociateFactureModal"
              >
                <div class="mb-3">
                  <b-form-input
                    v-model="associateFactureModal.search"
                    placeholder="Rechercher par numéro ou nom..."
                    size="sm"
                  />
                </div>
                <div v-if="associateFactureModal.loading" class="text-center py-4">
                  <b-spinner small></b-spinner>
                  <span class="ml-2">Chargement des factures...</span>
                </div>
                <div v-else-if="!filteredAssociateFactureList.length" class="text-center text-muted py-4">
                  Aucune facture disponible pour ce client.
                </div>
                <div v-else class="table-responsive associate-modal-table">
                  <table class="table table-sm table-hover">
                    <thead class="thead-light">
                      <tr>
                        <th style="width: 40px;">
                          <b-form-checkbox
                            :checked="associateFactureModal.selected.length === filteredAssociateFactureList.length && filteredAssociateFactureList.length > 0"
                            :indeterminate="associateFactureModal.selected.length > 0 && associateFactureModal.selected.length < filteredAssociateFactureList.length"
                            @change="toggleSelectAllAssociateFacture"
                          />
                        </th>
                        <th>N° Facture</th>
                        <th>N° Devis</th>
                       <!-- <th>Client</th>-->
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="facture in filteredAssociateFactureList" :key="facture.id">
                        <td>
                          <b-form-checkbox
                            :checked="associateFactureModal.selected.includes(getDevisId(facture))"
                            @change="toggleAssociateFactureSelection(getDevisId(facture))"
                          />
                        </td>
                        <td>{{ facture.devis?.numerofacture || facture.numerofacture || facture.id }}</td>
                        <td>
                          <span v-if="facture.devis?.numerodevis || facture.numerodevis" class="badge badge-secondary">{{ facture.devis?.numerodevis || facture.numerodevis }}</span>
                          <span v-else class="text-muted">-</span>
                        </td>
                      <!--  <td>{{ (facture.client || facture.devis?.client) ? [facture.client?.prenom || facture.devis?.client?.prenom, facture.client?.nom || facture.devis?.client?.nom].filter(Boolean).join(' ') : '-' }}</td>-->
                        <td>{{ formatCommentDate(facture.created_at) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <b-alert v-if="hasFactureWithDevis" show variant="warning" class="mt-3 mb-0">
                  <font-awesome-icon icon="exclamation-triangle" class="mr-1" />
                  <strong>Attention :</strong> Certaines factures sélectionnées ont un devis associé. Ces devis seront également associés au dossier.
                </b-alert>
                <div class="d-flex justify-content-between align-items-center mt-3">
                  <span class="text-muted">{{ associateFactureModal.selected.length }} facture(s) sélectionnée(s)</span>
                  <div>
                    <b-button variant="secondary" class="mr-2" @click="$refs.associateFactureModal.hide()">
                      Annuler
                    </b-button>
                    <b-button
                      variant="primary"
                      :disabled="!associateFactureModal.selected.length || associateFactureModal.saving"
                      @click="submitAssociateFacture"
                    >
                      <b-spinner v-if="associateFactureModal.saving" small class="mr-1"></b-spinner>
                      Associer
                    </b-button>
                  </div>
                </div>
              </b-modal>
            </b-tab>

            <!-- Onglet Photo -->
            <b-tab :title="$t('PHOTO') || 'Photo'" lazy>
              <div class="photo-tab">
                <div class="photo-toolbar">
                  <div class="photo-toolbar-buttons">
                    <b-button
                      variant="primary"
                      size="sm"
                      class="text-white"
                      :disabled="isDossierLocked"
                      @click="openPhotoModal"
                    >
                      <font-awesome-icon icon="plus" /> {{ "Ajouter photo" }}
                    </b-button>
                    <b-button
                      variant="outline-primary"
                      size="sm"
                      :disabled="isDossierLocked"
                      @click="openImportPhotoModal"
                    >
                      <font-awesome-icon icon="file-import" /> {{  "Importer" }}
                    </b-button>
                    <b-button
                      variant="success"
                      size="sm"
                      :disabled="!photos.length"
                      @click="exportPhotos"
                    >
                      <font-awesome-icon icon="file-export" />
                      {{ selectedPhotoIds.length ? ( "Exporter la sélection") + " (" + selectedPhotoIds.length + ")" : ("Exporter") }}
                    </b-button>
                  </div>
                  <div class="photo-view-toggle">
                    <b-button-group size="sm">
                      <b-button
                        :variant="photoViewMode === 'table' ? 'primary' : 'outline-primary'"
                        @click="photoViewMode = 'table'"
                        :title="'Vue tableau'"
                      >
                        <font-awesome-icon icon="table" />
                      </b-button>
                      <b-button
                        :variant="photoViewMode === 'grid' ? 'primary' : 'outline-primary'"
                        @click="photoViewMode = 'grid'"
                        :title=" 'Vue grille'"
                      >
                        <font-awesome-icon icon="th-large" />
                      </b-button>
                    </b-button-group>
                  </div>
                </div>
                <div class="photo-filters d-flex align-items-center mt-2 mb-2" style="gap: 1rem;">
                  <b-form-input
                    v-model="photoFilterName"
                    :placeholder=" 'Filtrer par nom'"
                    size="sm"
                    style="max-width: 220px;"
                    @input="onPhotoFilterChange"
                  />
                  <multiselect
                    v-model="photoFilterGallery"
                    :options="getAllgallery || []"
                    :placeholder="'Filtrer par catégorie'"
                    size="sm"
                    style="max-width: 200px;"
                    label="titre"
                    track-by="id"
                    :searchable="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :loading="getLoadinggallery"
                    :internal-search="false"
                    :options-limit="10"
                    :limit="1"
                    :max-height="200"
                    :show-no-results="false"
                    :hide-selected="true"
                    :multiple="false"
                    @input="onPhotoFilterChange"
                  >
                    <template #noResult>
                      {{ 'Aucun résultat trouvé' }}
                    </template>
                    <template #noOptions>
                      {{ 'Aucune catégorie disponible' }}
                    </template>
                  </multiselect>
                  <b-form-select
                    v-model="photoFilterStatus"
                    :options="[{ value: '', text: 'Tous les statuts' }, ...photoStatusOptions]"
                    value-field="value"
                    text-field="text"
                    size="sm"
                    style="max-width: 180px;"
                    @change="onPhotoFilterChange"
                  />
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="resetPhotoFilters"
                    :title="'Réinitialiser les filtres'"
                  >
                    <font-awesome-icon icon="times" />
                  </b-button>
                </div>
                <div class="photo-content">
                  <b-spinner v-if="photosLoading" class="d-block mx-auto my-3" small></b-spinner>
                  <!-- Vue tableau : afficher le tableau avec header même sans image -->
                  <div v-show="photoViewMode === 'table' && !photosLoading" class="table-rapport-style w-100 photo-table-wrap">
                    <table class="photo-table">
                      <thead>
                        <tr>
                          <th style="width: 40px; border-radius: 5px 0 0 0">
                            <b-form-checkbox
                              :checked="photos.length > 0 && selectedPhotoIds.length === photos.length"
                              :indeterminate="selectedPhotoIds.length > 0 && selectedPhotoIds.length < photos.length"
                              @change="toggleSelectAllPhotos"
                            />
                          </th>
                          <th>{{  "Image" }}</th>
                          <th>{{  "Nom de l'image" }}</th>
                          <th>{{  "Date de déploiement" }}</th>
                          <th>{{  "Statut" }}</th>
                          <th>{{  "Action" }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="photo in filteredPhotos" :key="photo.id" class="ligneNormale">
                          <td class="photo-check-cell">
                            <b-form-checkbox
                              :checked="selectedPhotoIds.includes(photo.id)"
                              @change="togglePhotoSelection(photo.id)"
                            />
                          </td>
                          <td class="photo-thumb-cell">
                         
                            <img
                            class="photo-thumb"
                            :src="downloadUrl + getPhotoSrc(photo)"
                            :alt="photo.name"
                            @click="openPhotoViewModal(photo)"
                            style="cursor: pointer;"
                          />
                          </td>
                          <td>{{ photo.name }}</td>
                          <td>{{ formatCommentDate(photo.created_at || photo.createdAt) }}</td>
                          <td>
                            <b-form-select
                              :value="photo.status || 'en_attente'"
                              :options="photoStatusOptions"
                              value-field="value"
                              text-field="text"
                              size="sm"
                              :disabled="isDossierLocked"
                              @change="updatePhotoStatus(photo, $event)"
                            />
                          </td>
                          <td class="photo-actions">
                            <b-button size="sm" variant="outline-primary" @click="exportSinglePhoto(photo)" class="mr-1">
                              <font-awesome-icon icon="download" />
                            </b-button>
                            <b-button size="sm" variant="outline-danger" :disabled="isDossierLocked" @click="removePhoto(photo)">
                              <font-awesome-icon icon="trash" />
                            </b-button>
                          </td>
                        </tr>
                        <tr v-if="photoViewMode === 'table' && !filteredPhotos.length">
                          <td colspan="6" class="photo-empty-row text-center text-muted py-4">
                            {{ "Aucune photo pour ce dossier." }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- Vue grille : afficher la grille si des photos, sinon message vide -->
                  <div v-show="photoViewMode === 'grid' && !photosLoading" class="photo-grid-wrap">
                    <div v-if="filteredPhotos.length" class="photo-grid">
                      <div
                        v-for="photo in filteredPhotos"
                        :key="photo.id"
                        class="photo-grid-card"
                        :class="{ 'photo-grid-card-selected': selectedPhotoIds.includes(photo.id) }"
                      >
                        <div class="photo-grid-check">
                          <b-form-checkbox
                            :checked="selectedPhotoIds.includes(photo.id)"
                            @change="togglePhotoSelection(photo.id)"
                          />
                        </div>
                        <div class="photo-grid-thumb">
                       
                          <img
                            :src="downloadUrl + getPhotoSrc(photo)"
                            :alt="photo.name"
                            @click="openPhotoViewModal(photo)"
                            style="cursor: pointer;"
                          />
                        </div>
                        <div class="photo-grid-info">
                          <span class="photo-grid-name" :title="photo.name">{{ photo.name }}</span>
                          <span class="photo-grid-date">{{ formatCommentDate(photo.created_at || photo.createdAt) }}</span>
                        </div>
                        <div class="photo-grid-actions">
                          <b-button size="sm" variant="outline-primary" @click="exportSinglePhoto(photo)" class="mr-1">
                            <font-awesome-icon icon="download" />
                          </b-button>
                          <b-button size="sm" variant="outline-danger" @click="removePhoto(photo)">
                            <font-awesome-icon icon="trash" />
                          </b-button>
                        </div>
                      </div>
                    </div>
                    <div v-else class="empty-tab">
                      <font-awesome-icon icon="images" class="empty-icon" />
                      <p>{{ "Aucune photo pour ce dossier." }}</p>
                      <p class="small text-muted">{{ "Utilisez le bouton Ajouter photo pour enregistrer des images." }}</p>
                    </div>
                  </div>
                </div>

                <!-- Modal pour afficher l'image en grand -->
                <b-modal
                  v-model="photoViewModal.show"
                  :title="photoViewModal.photo ? photoViewModal.photo.name : ''"
                  size="lg"
                  centered
                  hide-footer
                  @hidden="closePhotoModal"
                >
                  <div v-if="photoViewModal.photo" class="text-center">
                
                    <img
                      :src="downloadUrl + getPhotoSrc(photoViewModal.photo)"
                      :alt="photoViewModal.photo.name"
                      class="img-fluid"
                      style="max-height: 70vh; object-fit: contain;"
                    />
                    <div class="mt-3">
                      <p class="mb-1"><strong>{{ 'Nom de l\'image' }}:</strong> {{ photoViewModal.photo.name }}</p>
                      <p class="mb-1"><strong>{{ 'Date de déploiement' }}:</strong> {{ formatCommentDate(photoViewModal.photo.created_at || photoViewModal.photo.createdAt) }}</p>
                      <p class="mb-0"><strong>{{ 'Statut' }}:</strong> 
                        <span :class="getPhotoStatusClass(photoViewModal.photo.status)">
                          {{ getPhotoStatusText(photoViewModal.photo.status) }}
                        </span>
                      </p>
                    </div>
                  </div>
                </b-modal>

                <!-- Modal Import photos (images[] ou archive.zip) -->
                <b-modal
                  id="importPhotoModal"
                  ref="importPhotoModal"
                  :title=" 'Importer des photos'"
                  hide-footer
                  @hidden="resetImportPhotoModal"
                >
                  <b-form @submit.prevent="submitImportPhotos">
                    <b-form-group label="">
                      <b-form-radio-group v-model="importPhotoMode" class="mb-3">
                        <b-form-radio value="images">{{ "Importer des images" }} (images[])</b-form-radio>
                        <b-form-radio value="archive">{{  "Importer une archive" }} (.zip)</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group v-if="importPhotoMode === 'images'" :label="'Images (plusieurs fichiers)'">
                      <b-form-file
                        v-model="importPhotoFiles"
                        accept="image/*"
                        multiple
                        :placeholder=" 'Choisir des images'"
                        drop-placeholder="Déposer les images ici"
                      />
                    </b-form-group>
                    <b-form-group v-if="importPhotoMode === 'archive'" :label="'Archive ZIP'">
                      <b-form-file
                        v-model="importPhotoArchive"
                        accept=".zip"
                        :placeholder="'Choisir un fichier .zip'"
                        drop-placeholder="Déposer le fichier .zip ici"
                      />
                    </b-form-group>
                    <div class="d-flex justify-content-end mt-3">
                      <b-button variant="secondary" class="mr-2" @click="$refs.importPhotoModal.hide()">
                        {{  "Annuler" }}
                      </b-button>
                      <b-button variant="success" type="submit" :disabled="photoImportSaving || !hasImportPhotoFiles">
                        <b-spinner v-if="photoImportSaving" small class="mr-1"></b-spinner>
                        {{  "Importer" }}
                      </b-button>
                    </div>
                  </b-form>
                </b-modal>

                <!-- Modal Ajouter photo -->
                <b-modal
                  id="photoModal"
                  ref="photoModal"
                  :title=" 'Ajouter photo'"
                  hide-footer
                  @hidden="resetPhotoModal"
                >
                  <b-form @submit.prevent="savePhoto">
                    <b-form-group :label="photoNameLabel" label-for="photo-name">
                      <b-form-input
                        id="photo-name"
                        v-model="photoModal.name"
                        :placeholder=" 'Ex: Photo chantier'"
                        required
                      />
                    </b-form-group>
                    <b-form-group :label="'Image'" label-for="photo-file">
                      <b-form-file
                        id="photo-file"
                        v-model="photoModal.file"
                        accept="image/*"
                        :placeholder=" 'Choisir un fichier'"
                        drop-placeholder="Déposer l'image ici"
                        required
                      />
                    </b-form-group>
                    <b-form-group :label=" 'Statut'" label-for="photo-status">
                      <b-form-select
                        id="photo-status"
                        v-model="photoModal.status"
                        :options="photoStatusOptions"
                        value-field="value"
                        text-field="text"
                      />
                    </b-form-group>
                    <b-form-group :label=" 'Catégorie'" label-for="photo-category">
                      <multiselect
                        id="photo-category"
                        v-model="photoModal.gallery"
                        :options="getAllgallery || []"
                        :placeholder=" 'Sélectionner une catégorie'"
                        label="titre"
                        track-by="id"
                        :searchable="true"
                        :close-on-select="true"
                        :clear-on-select="false"
                        :loading="getLoadinggallery"
                        :internal-search="false"
                        :options-limit="10"
                        :limit="3"
                        :limit-text="limitText"
                        :max-height="200"
                        :show-no-results="false"
                        :hide-selected="true"
                        :multiple="false"
                      >
                        <template #noResult>
                          {{  'Aucun résultat trouvé' }}
                        </template>
                        <template #noOptions>
                          {{  'Aucune catégorie disponible' }}
                        </template>
                      </multiselect>
                    </b-form-group>
                    <div class="d-flex justify-content-end mt-3">
                      <b-button variant="secondary" class="mr-2" @click="$refs.photoModal.hide()">
                        {{  "Annuler" }}
                      </b-button>
                      <b-button variant="success" type="submit" :disabled="photoSaving">
                        <b-spinner v-if="photoSaving" small class="mr-1"></b-spinner>
                        {{ "Enregistrer" }}
                      </b-button>
                    </div>
                  </b-form>
                </b-modal>
              </div>
            </b-tab>

            <!-- Onglet Commentaire -->
            <b-tab :title=" 'Commentaire'" lazy>
              <div class="commentaire-tab">
                <div class="commentaire-grid">
                  <div class="commentaire-col">
                    <div class="info-card">
                      <div class="divborder">
                        <p>{{ "Ajouter un commentaire" }}</p>
                      </div>
                      <div class="commentaire-editor-wrap">
                        <vue-editor
                          v-model="commentText"
                          :placeholder=" 'Saisir votre commentaire...'"
                          class="commentaire-editor"
                          :editor-toolbar="customToolbar"
                        />
                        <b-button
                          variant="success"
                          size="sm"
                          class="mt-2"
                          @click="addComment"
                          :disabled="isDossierLocked || commentSaving || !commentText || (commentText && commentText.replace(/<[^>]*>/g, '').trim() === '')"
                        >
                          <b-spinner v-if="commentSaving" small class="mr-1"></b-spinner>
                          <font-awesome-icon v-else icon="plus" /> {{  "Ajouter" }}
                        </b-button>
                      </div>
                    </div>
                  </div>
                  <div class="commentaire-col">
                    <div class="info-card">
                      <div class="divborder">
                        <p>{{  "Commentaires" }} ({{ comments.length }})</p>
                      </div>
                      <b-spinner v-if="commentsLoading" class="d-block mx-auto my-3" small></b-spinner>
                      <div class="commentaire-list" v-else-if="comments.length">
                        <div
                          v-for="comment in comments"
                          :key="comment.id"
                          class="commentaire-item"
                        >
                          <div class="commentaire-item-header">
                            <div class="commentaire-meta">
                              <span class="commentaire-author">{{ getCommentAuthor(comment) }}</span>
                              <span class="commentaire-date">{{ formatCommentDate(comment.created_at || comment.createdAt) }}</span>
                            </div>
                            <div class="commentaire-actions">
                              <b-button
                                size="sm"
                                variant="outline-primary"
                                class="commentaire-edit"
                                @click="startEditComment(comment)"
                                :disabled="isDossierLocked || commentEditSaving"
                              >
                                <font-awesome-icon icon="edit" />
                              </b-button>
                              <b-button
                                size="sm"
                                variant="outline-danger"
                                class="commentaire-delete"
                                @click="removeComment(comment)"
                                :disabled="isDossierLocked || commentSaving"
                              >
                                <font-awesome-icon icon="trash" />
                              </b-button>
                            </div>
                          </div>
                          <div v-if="commentEditingId === comment.id" class="commentaire-edit-wrap">
                            <vue-editor
                              v-model="commentEditText"
                              class="commentaire-editor"
                              :editor-toolbar="customToolbar"
                            />
                            <div class="d-flex justify-content-end mt-2">
                              <b-button
                                size="sm"
                                variant="secondary"
                                class="mr-2"
                                @click="cancelEditComment"
                                :disabled="commentEditSaving"
                              >
                                {{ $t("CANCEL") || "Annuler" }}
                              </b-button>
                              <b-button
                                size="sm"
                                variant="success"
                                @click="saveEditComment"
                                :disabled="commentEditSaving || !commentEditText || (commentEditText && commentEditText.replace(/<[^>]*>/g, '').trim() === '')"
                              >
                                <b-spinner v-if="commentEditSaving" small class="mr-1"></b-spinner>
                                {{ $t("SAVE") || "Enregistrer" }}
                              </b-button>
                            </div>
                          </div>
                          <div v-else class="commentaire-content ql-editor" v-html="comment.contenu || comment.content"></div>
                        </div>
                      </div>
                      <div v-else class="empty-tab">
                        <font-awesome-icon icon="comment-alt" class="empty-icon" />
                        <p>{{ $t("AUCUN_COMMENTAIRE") || "Aucun commentaire pour ce dossier." }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </template>

      <div v-else-if="!loading && error" class="alert alert-danger m-3">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { domains } from "@/environment";

export default {
  name: "DossierDetail",
  data() {
    return {
      dossierDetail: null,
      loading: true,
      downloadUrl: domains.download,
      error: null,
      fileLoading: [],
      commentText: "",
      comments: [],
      commentsLoading: false,
      commentSaving: false,
      commentEditingId: null,
      commentEditText: "",
      commentEditSaving: false,
      photos: [],
      selectedPhotoIds: [],
      photosLoading: false,
      photoSaving: false,
      photoModal: { name: "", file: null, status: "en_attente", gallery: null },
      photoStatusOptions: [
        { value: "en_attente", text: "En attente" },
        { value: "en_cours", text: "En cours" },
        { value: "a_verifier", text: "À vérifier" },
        { value: "verifie", text: "Vérifié" },
      ],
      importPhotoMode: "images",
      importPhotoFiles: null,
      importPhotoArchive: null,
      photoImportSaving: false,
      photoViewMode: "grid",
      photoFilterName: "",
      photoFilterStatus: "",
      photoFilterGallery: null,
      photoFilters: {
        search: "",
        status: "",
        gallery_id: null,
        page: 1,
        per_page: 1000
      },
      // Modal pour afficher l'image en grand
      photoViewModal: {
        show: false,
        photo: null,
      },
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ header: 1 }, { header: 2 }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image"],
        ["clean"],
      ],
      dossierDocument: null,
      documentLoading: false,
      documentPdfLoadingId: null,
      documentExportLoading: false,
      documentImportSaving: false,
      importComplementairesFiles: null,
      importComplementairesCategory: null,
      // Modal association devis/facture
      associateDevisModal: {
        show: false,
        loading: false,
        saving: false,
        list: [],
        selected: [],
        search: "",
      },
      associateFactureModal: {
        show: false,
        loading: false,
        saving: false,
        list: [],
        selected: [],
        search: "",
      },
      associateCEEModal: {
        show: false,
        loading: false,
        saving: false,
        list: [],
        selected: [],
        search: "",
      },
      associateAHModal: {
        show: false,
        loading: false,
        saving: false,
        list: [],
        selected: [],
        search: "",
      },
      selectedDocumentIndices: [],
      documentSearch: "",
      documentFilterCategories: null,
      documentSearchTimeout: null,
      statusFallbacks: {
        DOSSIER_STATUS_EN_COURS: "Dossier en cours",
        DOSSIER_STATUS_NON_SIGNE: "Dossier non signé",
        DOSSIER_STATUS_SIGNE: "Dossier signé",
        DOSSIER_STATUS_POSE_EN_COURS: "Pose en cours",
        DOSSIER_STATUS_POSE_TERMINE: "Pose terminé",
        DOSSIER_STATUS_CONTROLE_A_PLANIFIER: "Contrôle à planifier",
        DOSSIER_STATUS_TRAITEMENT_ADMIN: "En traitement administratif",
        DOSSIER_STATUS_A_DEPOSER: "Dossier à déposer",
        DOSSIER_STATUS_DEPOSE: "Dossier déposé",
        DOSSIER_STATUS_PAYE: "Dossier payé",
      },
    };
  },
  computed: {
    ...mapGetters(["getOcrFileType", "getOcrFiles", "getTabs", "getOnlineUser", "getAllgallery", "getLoadinggallery", "getDocumentCategories", "getDocumentCategoriesLoading"]),
    dossierId() {
      return this.$route.params.id;
    },
    isDossierLocked() {
      return this.dossierDetail?.lock === 1;
    },
    filteredPhotos() {
      // Le filtrage est maintenant fait côté serveur via loadPhotos()
      return this.photos;
    },
    filteredAssociateDevisList() {
      const search = (this.associateDevisModal.search || "").toLowerCase();
      if (!search) return this.associateDevisModal.list;
      return this.associateDevisModal.list.filter((d) => {
        const num = String(d.numerodevis || d.numero || d.id || "").toLowerCase();
        const nom = d.client ? [d.client.prenom, d.client.nom].filter(Boolean).join(" ").toLowerCase() : "";
        return num.includes(search) || nom.includes(search);
      });
    },
    filteredAssociateFactureList() {
      const search = (this.associateFactureModal.search || "").toLowerCase();
      if (!search) return this.associateFactureModal.list;
      return this.associateFactureModal.list.filter((f) => {
        const num = String(f.devis?.numerofacture ?? f.devis?.numerodevis ?? f.numerofacture ?? f.id ?? "").toLowerCase();
        const nom = (f.client || f.devis?.client) ? [f.client?.prenom || f.devis?.client?.prenom, f.client?.nom || f.devis?.client?.nom].filter(Boolean).join(" ").toLowerCase() : "";
        return num.includes(search) || nom.includes(search);
      });
    },
    filteredAssociateCEEList() {
      const search = (this.associateCEEModal.search || "").toLowerCase();
      if (!search) return this.associateCEEModal.list;
      return this.associateCEEModal.list.filter((c) => {
        const num = String(c.numero ?? c.id ?? "").toLowerCase();
        const nom = c.client ? [c.client.prenom, c.client.nom].filter(Boolean).join(" ").toLowerCase() : "";
        return num.includes(search) || nom.includes(search);
      });
    },
    filteredAssociateAHList() {
      const search = (this.associateAHModal.search || "").toLowerCase();
      if (!search) return this.associateAHModal.list;
      return this.associateAHModal.list.filter((a) => {
        const num = String(a.numero_sequence ?? a.numero ?? a.id ?? "").toLowerCase();
        const nom = (a.devis?.client || a.client) ? [(a.devis?.client || a.client).prenom, (a.devis?.client || a.client).nom].filter(Boolean).join(" ").toLowerCase() : "";
        return num.includes(search) || nom.includes(search);
      });
    },
    hasDevisWithFacture() {
      return this.associateDevisModal.selected.some((id) => {
        const devis = this.associateDevisModal.list.find((d) => this.getDevisId(d) === id);
        return devis && devis.numerofacture;
      });
    },
    hasFactureWithDevis() {
      return this.associateFactureModal.selected.some((id) => {
        const facture = this.associateFactureModal.list.find((f) => this.getDevisId(f) === id);
        return facture && (facture.devis?.numerodevis || facture.numerodevis);
      });
    },
    hasImportPhotoFiles() {
      if (this.importPhotoMode === "images") {
        const files = this.importPhotoFiles;
        return files && (Array.isArray(files) ? files.length : files) > 0;
      }
      return !!this.importPhotoArchive;
    },
    hasImportComplementairesFiles() {
      const f = this.importComplementairesFiles;
      return f && (Array.isArray(f) ? f.length : 1) > 0;
    },
    photoNameLabel() {
      return "Nom de l'image";
    },
    documentRows() {
      const doc = this.dossierDocument;
      if (doc) {
        const rows = [];
        (doc.devis || []).forEach((item) => {
          rows.push({
            typeId: `devis-${item.id}`,
            typeLabel: this.$t("DEVIS") || "Devis",
            numero: item.numerodevis ?? item.numero ?? item.id,
            nom: item.name ?? (item.client ? [item.client.prenom, item.client.nom].filter(Boolean).join(" ") : null) ?? "-",
            date: item.created_at ?? item.date,
            file: item.file ?? null,
            raw: item,
            downloadType: "devis",
            downloadId: item.id,
          });
          if (item.numerofacture) {
            rows.push({
              typeId: `facture-${item.id}`,
              typeLabel: this.$t("FACTURE") || "Facture",
              numero: item.numerofacture ?? item.numero ?? item.id,
              nom: item.name ?? (item.client ? [item.client.prenom, item.client.nom].filter(Boolean).join(" ") : null) ?? "-",
              date: item.created_at ?? item.date,
              file: item.file ?? null,
              raw: item,
              downloadType: "facture",
              downloadId: item.id,
            });
          }
        });
        (doc.cee || []).forEach((item) => {
          rows.push({
            typeId: `cee-${item.id}`,
            typeLabel: "CC",
            numero: item.numero_sequence ?? item.numero ?? item.id,
            nom: item.type_prime ?? item.name ?? "-",
            date: item.created_at ?? item.date,
            file: item.file ?? item.pdf_path ?? null,
            raw: item,
            downloadType: "cee",
            downloadId: item.id,
          });
        });
        (doc.ah || []).forEach((item) => {
          rows.push({
            typeId: `ah-${item.id}`,
            typeLabel: "AH",
            numero: item.numero_sequence ?? item.numero ?? item.id,
            nom: item.name ?? "-",
            date: item.created_at ?? item.date,
            file: item.file ?? item.pdf_path ?? null,
            raw: item,
            downloadType: "ah",
            downloadId: item.id,
          });
        });
        (doc.document_complementaires || []).forEach((item) => {
          const categoryLabel = item.category?.label || item.category_label || null;
          rows.push({
            typeId: `complementaire-${item.id}`,
            typeLabel: categoryLabel || this.$t("COMPLEMENTAIRE") || "Complémentaire",
            numero: item.numero ?? item.id,
            nom: item.type ?? "-",
            date: item.date_creation ?? item.created_at ?? null,
            file: item.pdf ?? null,
            raw: item,
            downloadType: "complementaire",
            downloadId: item.id,
            pdfPath: item.pdf,
            category: item.category || null,
          });
        });
        return rows;
      }
      const types = this.getOcrFileType || [];
      return types.map((ocrDoc) => {
        const file = ocrDoc.file || {};
        return {
          typeId: ocrDoc.id,
          typeLabel: ocrDoc.name || "-",
          numero: file.numero ?? file.numero_document ?? file.numerodevis ?? file.numerofacture ?? null,
          nom: file.name ?? file.nom ?? ocrDoc.name ?? null,
          date: file.created_at ?? file.date ?? null,
          file: ocrDoc.file,
          raw: ocrDoc,
        };
      });
    },
 
    documentCategoryFilterOptions() {
      const allOption = { id: "__all__", label: this.$t("ALL") || "Tous", filterType: "all" };
      
      // Types de documents principaux
      const mainTypes = [
        { id: "__devis__", label: this.$t("DEVIS") || "Devis", filterType: "downloadType", filterValue: "devis" },
        { id: "__facture__", label: this.$t("FACTURE") || "Facture", filterType: "downloadType", filterValue: "facture" },
        { id: "__cc__", label: "CC", filterType: "downloadType", filterValue: "cee" },
        { id: "__ah__", label: "AH", filterType: "downloadType", filterValue: "ah" },
        { id: "__complementaire__", label: this.$t("COMPLEMENTAIRE") || "Complémentaire", filterType: "downloadType", filterValue: "complementaire" },
      ];
      
      return [allOption, ...mainTypes];
    },
    filteredDocumentRows() {
      let list = this.documentRows.map((doc, index) => ({ doc, index }));
      
      // Filtrer par catégorie/type de document
      const selectedFilter = this.documentFilterCategories;
      if (selectedFilter && selectedFilter.id !== "__all__") {
        if (selectedFilter.filterType === "downloadType") {
          list = list.filter(({ doc }) => doc.downloadType === selectedFilter.filterValue);
        }
      }
      
      // Filtrer par recherche textuelle
      const search = (this.documentSearch || "").trim().toLowerCase();
      if (search) {
        list = list.filter(({ doc }) => {
          const typeLabel = (doc.typeLabel || "").toLowerCase();
          const numero = String(doc.numero || "").toLowerCase();
          const dateStr = this.formatDocumentDate(doc.date).toLowerCase();
          return typeLabel.includes(search) || numero.includes(search) || dateStr.includes(search);
        });
      }

      return list;
    },
  },
  watch: {
    dossierId: {
      immediate: true,
      handler(id) {
        if (id) this.loadDossier();
      },
    },
  },
  methods: {
    ...mapActions([
      "one_dossier",
      "OcrFileTypes",
      "allfiles",
      "download_file",
      "index_commentaires",
      "store_commentaire",
      "update_commentaire",
      "destroy_commentaire",
      "index_photos",
      "store_photo",
      "update_photo",
      "destroy_photo",
      "import_photos",
      "export_photos",
      "fetchDocumentCategories",
      "get_dossier_document",
      "export_dossier_documents",
      "import_document_documents",
      "delete_document_complementaire",
      "dissociate_documents",
      "associate_documents",
      "allCEE",
      "allAH",
      "delete_devis",
      "deleteAH",
      "deleteCEE",
      "allgallery",
    ]),
    moment(date) {
      return moment(date);
    },
     download() {
      if (this.pdfInfo.document.is_signed == "stored")
        window.open(this.pdfInfo.pdf, "_blank");
      else window.open(this.downloadUrl + this.pdfInfo.pdf, "_blank");
    },
    getStatusLabel(status) {
      if (!status) return "-";
      const translated = this.$t(status);
      if (translated !== status) return translated;
      return this.statusFallbacks[status] || status;
    },
    getStatusChipClass(status) {
      if (!status) return "chip-default";
      const map = {
        DOSSIER_STATUS_EN_COURS: "chip-en-cours",
        DOSSIER_STATUS_NON_SIGNE: "chip-non-signe",
        DOSSIER_STATUS_SIGNE: "chip-signe",
        DOSSIER_STATUS_POSE_EN_COURS: "chip-pose-en-cours",
        DOSSIER_STATUS_POSE_TERMINE: "chip-pose-termine",
        DOSSIER_STATUS_CONTROLE_A_PLANIFIER: "chip-controle",
        DOSSIER_STATUS_TRAITEMENT_ADMIN: "chip-traitement-admin",
        DOSSIER_STATUS_A_DEPOSER: "chip-a-deposer",
        DOSSIER_STATUS_DEPOSE: "chip-depose",
        DOSSIER_STATUS_PAYE: "chip-paye",
      };
      return map[status] || "chip-default";
    },
    fusionFileType() {
      this.getOcrFileType.forEach((type) => {
        type.file = null;
      });
      this.getOcrFiles.forEach((file) => {
        this.getOcrFileType.forEach((type) => {
          if (type.id == file.ocr_file_type_id) type.file = file;
        });
      });
    },
    async loadDossier() {
      if (!this.dossierId) return;
      this.loading = true;
      this.error = null;
      try {
        this.dossierDetail = await this.one_dossier(this.dossierId);
        await this.OcrFileTypes({});
        await this.fetchDocumentCategories({
          page: 1,
          per_page: 1000,
          search: ''
        });
        this.getOcrFileType.forEach(() => this.fileLoading.push(false));
        await this.allfiles(this.dossierId);
        this.fusionFileType();
        await this.loadComments();
        await this.loadPhotos();
        await this.loadDossierDocument();
        // Charger les galleries pour le multiselect de catégories
        await this.allgallery({
          page: 1,
          per_page: 1000,
          search: ''
        });
      } catch (err) {
        this.error = err && (err.message || err) ? String(err.message || err) : this.$t("ERROR_LOAD") || "Erreur lors du chargement.";
        this.dossierDetail = null;
      } finally {
        this.loading = false;
      }
    },
    async exportSelectedDocuments() {
      const indices = [...this.selectedDocumentIndices].filter((i) => i >= 0 && i < this.documentRows.length);
      if (!indices.length) return;
      const allowedTypes = ["devis", "facture", "ah", "cee", "cc"];
      const documents = indices
        .map((i) => this.documentRows[i])
        .filter((doc) => doc && doc.downloadId && allowedTypes.includes(doc.downloadType))
        .map((doc) => ({ id: doc.downloadId, type: doc.downloadType }));
      if (!documents.length) {
        this.$bvToast &&
          this.$bvToast.toast(
            this.$t("EXPORT_DOCUMENTS_SELECT_TYPES") || "Sélectionnez des documents de type Devis, Facture, CC ou AH.",
            { variant: "warning", autoHideDelay: 4000 }
          );
        return;
      }
      if (!this.dossierId) return;
      this.documentExportLoading = true;
      try {
        const result = await this.export_dossier_documents({
          ocrdossierId: this.dossierId,
          documents,
        });
        if (!result || !result.blob) return;
        let filename = "documents_export.zip";
        const disposition = result.headers && result.headers["content-disposition"];
        if (disposition) {
          const match =
            disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i) ||
            disposition.match(/filename=["']?([^"';]+)["']?/i);
          if (match && match[1]) filename = match[1].trim();
        }
        const url = window.URL.createObjectURL(result.blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.$bvToast &&
          this.$bvToast.toast(this.$t("EXPORT_SUCCESS") || "Export téléchargé.", { variant: "success", autoHideDelay: 3000 });
      } catch (err) {
        this.$bvToast &&
          this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", {
            variant: "danger",
            autoHideDelay: 5000,
          });
      } finally {
        this.documentExportLoading = false;
      }
    },
    downloadComplementairePdf(doc) {
      if (!doc || !doc.pdfPath) return;
      const base = domains.download || "";
      const path = doc.pdfPath.startsWith("/") ? doc.pdfPath.slice(1) : doc.pdfPath;
      const url = base ? (base.endsWith("/") ? base + path : base + "/" + path) : path;
      window.open(url, "_blank");
    },
    openDocumentView(doc) {
      if (!doc || !doc.downloadId) return;
      if (doc.downloadType === "devis" || doc.downloadType === "facture") {
        this.$router.push({
          path: "/documents/" + doc.downloadId,
          query: { type: doc.downloadType },
        });
      }
    },
    editDocument(doc) {
      if (!doc || !doc.downloadId) return;
      if (doc.downloadType === "devis" || doc.downloadType === "facture") {
        this.$router.push({ path: "/devis/update/" + doc.downloadId });
      }
    },
    confirmDeleteDocument(doc) {
      if (!doc || !doc.downloadId) return;
      const typeLabel = doc.typeLabel || doc.downloadType || "document";
      this.$bvModal
        .msgBoxConfirm( `Supprimer ce ${typeLabel} ?`, {
          title: this.$t("CONFIRM") || "Confirmer",
          okVariant: "danger",
          okTitle: this.$t("DELETE") || "Supprimer",
          cancelTitle: this.$t("CANCEL") || "Annuler",
        })
        .then((ok) => {
          if (ok) this.handleDeleteDocument(doc);
        });
    },
    async handleDeleteDocument(doc) {
      if (!doc || !doc.downloadId) return;
      const type = doc.downloadType;
      try {
        if (type === "complementaire") {
          await this.delete_document_complementaire(doc.downloadId);
        } else if (type === "ah") {
          await this.deleteAH({ id: doc.downloadId });
        } else if (type === "cee") {
          await this.deleteCEE({ id: doc.downloadId });
        } else if (type === "cc") {
          await this.deleteCEE({ id: doc.downloadId });
        } else if (type === "devis" || type === "facture") {
          await this.delete_devis({ id: doc.downloadId });
        } else return;
        this.$bvToast &&
          this.$bvToast.toast( "Supprimé.", { variant: "success", autoHideDelay: 3000 });
        await this.loadDossierDocument();
      } catch (err) {
        this.$bvToast &&
          this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", {
            variant: "danger",
            autoHideDelay: 5000,
          });
      }
    },
    confirmDissociateDocument(doc) {
      if (!doc || !doc.downloadId) return;
      const type = doc.downloadType;
      if (type !== "devis" && type !== "facture" && type !== "ah" && type !== "cee" && type !== "cc") return;
      const typeLabel = doc.typeLabel || type || "document";
      
      // Vérifier si devis et facture ont le même ID (les deux numéros existent)
      let warningMessage = `Dissocier ce ${typeLabel} du dossier ?`;
      const raw = doc.raw;
      if ((type === "devis" || type === "facture") && raw && raw.numerodevis && raw.numerofacture) {
        if (type === "devis") {
          warningMessage = `Dissocier ce devis du dossier ?\n\nAttention : La facture n° ${raw.numerofacture} associée sera également dissociée car elle dépend de ce devis.`;
        } else {
          warningMessage = `Dissocier cette facture du dossier ?\n\nAttention : Le devis n° ${raw.numerodevis} associé sera également dissocié car cette facture en dépend.`;
        }
      }
      
      this.$bvModal
        .msgBoxConfirm(warningMessage, {
          title: "Confirmer",
          okVariant: "warning",
          okTitle: "Dissocier",
          cancelTitle: "Annuler",
        })
        .then((ok) => {
          if (ok) this.handleDissociateDocument(doc);
        });
    },
    async handleDissociateDocument(doc) {
      if (!doc || !doc.downloadId) return;
      const type = doc.downloadType;
      const payload = {
        ocrdossierId: this.dossierId,
        devis_ids: [],
        cee_ids: [],
        ah_ids: [],
      };
      if (type === "devis" || type === "facture") {
        // Devis et facture partagent le même ID
        payload.devis_ids = [doc.downloadId];
      } else if (type === "ah") {
        payload.ah_ids = [doc.downloadId];
      } else if (type === "cee") {
        payload.cee_ids = [doc.downloadId];
      } else {
        return;
      }
      try {
        await this.dissociate_documents(payload);
        this.$bvToast &&
          this.$bvToast.toast(this.$t("DISSOCIATE_SUCCESS") || "Document dissocié.", { variant: "success", autoHideDelay: 3000 });
        await this.loadDossierDocument();
      } catch (err) {
        this.$bvToast &&
          this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", {
            variant: "danger",
            autoHideDelay: 5000,
          });
      }
    },
    async downloadDocumentPdf(doc) {
      if (!doc || !doc.downloadId) return;
      const type = doc.downloadType;
      if (type !== "devis" && type !== "facture" && type !== "ah" && type !== "cee" && type !== "cc") return;
      const key = doc.downloadId + "-" + (type || "");
      this.documentPdfLoadingId = key;
      try {
        if (type === "ah") {
          const response = await this.$store.dispatch("downloadPdfAH", doc.downloadId);
          this.documentPdfLoadingId = null;
          const data = response?.data ?? response;
          if (data) {
            if (data.download_url) {
              window.open(data.download_url, "_blank");
            } else if (data.pdf_path) {
              const url = domains.download + data.pdf_path.replace(/^storage\/app\/public\//, "");
              window.open(url, "_blank");
            }
          }
          return;
        }
        if (type === "cee") {
          const response = await this.$store.dispatch("downloadPdfCEE", doc.downloadId);
          this.documentPdfLoadingId = null;
          const data = response?.data ?? response;
          if (data) {
            if (data.download_url) {
              window.open(data.download_url, "_blank");
            } else if (data.pdf_path) {
              const url = domains.download + data.pdf_path.replace(/^storage\/app\/public\//, "");
              window.open(url, "_blank");
            }
          }
          return;
        }
        const response = await this.$store.dispatch("downloadDevis", {
          id: doc.downloadId,
          type,
        });
        this.documentPdfLoadingId = null;
        if (response && response.pdf) {
          const url = response.document && response.document.is_signed === "stored" ? response.pdf : domains.download + response.pdf;
          window.open(url, "_blank");
        }
      } catch (err) {
        this.documentPdfLoadingId = null;
        this.$bvToast && this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", { variant: "danger", autoHideDelay: 4000 });
        throw err;
      }
    },
    onDocumentCategoryFilterChange() {
      // Le filtrage est géré côté client via filteredDocumentRows
      // Pas besoin de recharger les documents
    },
    onDocumentSearchInput() {
      clearTimeout(this.documentSearchTimeout);
      this.documentSearchTimeout = setTimeout(() => {
        this.loadDossierDocument();
      }, 400);
    },
    async loadDossierDocument() {
      if (!this.dossierId) return;
      this.documentLoading = true;
      this.dossierDocument = null;
      try {
        // Préparer les paramètres avec les filtres de catégories et recherche
        const params = {};
        
        // Ajouter le search si présent
        if (this.documentSearch && this.documentSearch.trim()) {
          params.search = this.documentSearch.trim();
        }
        
        const data = await this.get_dossier_document({
          ocrdossierId: this.dossierId,
          params
        });
        this.dossierDocument = data;
      } catch (err) {
        if (!err.is404) {
          this.$bvToast && this.$bvToast.toast(err.message || this.$t("ERROR") || "Erreur", { variant: "danger", autoHideDelay: 4000 });
        }
        this.dossierDocument = null;
      } finally {
        this.documentLoading = false;
      }
    },
    downloadFile(doc, key) {
      if (!doc.file) return Promise.reject(new Error("No file"));
      this.$set(this.fileLoading, key, true);
      return this.download_file(doc.file.id)
        .then((file) => {
          const url = window.URL.createObjectURL(new Blob([file]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${doc.name || "document"}.pdf`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.$set(this.fileLoading, key, false);
        });
    },
    formatAdresse(client) {
      if (!client) return "-";
      const parts = [
        client.rue || client.adresse,
        client.complement_adresse,
        [client.cp || client.code_postal, client.ville].filter(Boolean).join(" "),
        client.pays && (typeof client.pays === "object" ? client.pays.name : client.pays),
      ].filter(Boolean);
      return parts.length ? parts.join(", ") : "-";
    },
    formatClientType(type) {
      if (!type) return "-";
      const labels = {
        "type.particulier": this.$t("PARTICULAR") || "Particulier",
        "type.professionnel": this.$t("PROFESSIONAL") || "Professionnel",
        "type.bailleur_sociale": this.$t("BAILLEUR_SOCIAL") || "Bailleur social",
      };
      return labels[type] || type;
    },
    goToEditClient(clientId) {
      if (!clientId) return;
      this.$router.push({ name: "Modifie client", params: { id: clientId } });
    },
    goToCreateDevis() {
      const query = {};
      const clientId = this.dossierDetail?.client_id || this.dossierDetail?.client?.id;
      if (clientId) query.clientId = clientId;
      if (this.dossierId) query.dossierId = this.dossierId;
      this.$router.push({ path: "/devis/devisTypes", query });
    },
    async goToDevisExistant() {
      this.resetAssociateDevisModal();
      this.$refs.associateDevisModal && this.$refs.associateDevisModal.show();
      await this.loadDevisForAssociation();
    },
    resetAssociateDevisModal() {
      this.associateDevisModal.list = [];
      this.associateDevisModal.selected = [];
      this.associateDevisModal.search = "";
      this.associateDevisModal.loading = false;
      this.associateDevisModal.saving = false;
    },
    async loadDevisForAssociation() {
      const clientId = this.dossierDetail?.client_id || this.dossierDetail?.client?.id;
      if (!clientId) {
        this.associateDevisModal.list = [];
        return;
      }
      const entrepriseId =
        this.dossierDetail?.entreprise_id ||
        this.dossierDetail?.entreprise?.id ||
        this.dossierDetail?.client?.entreprise_id ||
        this.getOnlineUser?.entreprise?.id;
      this.associateDevisModal.loading = true;
      try {
        // Récupérer les devis du client non associés à un dossier (ocrdossier_id = null)
        const response = await this.$store.dispatch("devis", {
          page: 1,
          per_page: 1000,
          client: clientId,
          ocrdossier_id: "null",
          entreprise_id: entrepriseId ?? undefined,
        });
        const allDevis = response?.data?.data || response?.data || [];
        this.associateDevisModal.list = allDevis;
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(String(err.message || err), { variant: "danger", autoHideDelay: 4000 });
        this.associateDevisModal.list = [];
      } finally {
        this.associateDevisModal.loading = false;
      }
    },
    getDevisId(item) {
      return item?.devis?.id ?? item?.devis_id ?? item?.id;
    },
    toggleSelectAllAssociateDevis(checked) {
      if (checked) {
        this.associateDevisModal.selected = this.filteredAssociateDevisList.map((d) => this.getDevisId(d));
      } else {
        this.associateDevisModal.selected = [];
      }
    },
    toggleAssociateDevisSelection(id) {
      const idx = this.associateDevisModal.selected.indexOf(id);
      if (idx === -1) {
        this.associateDevisModal.selected.push(id);
      } else {
        this.associateDevisModal.selected.splice(idx, 1);
      }
    },
    async submitAssociateDevis() {
      if (!this.associateDevisModal.selected.length) return;
      this.associateDevisModal.saving = true;
      try {
        await this.associate_documents({
          ocrdossierId: this.dossierId,
          devis_ids: this.associateDevisModal.selected,
        });
        this.$refs.associateDevisModal && this.$refs.associateDevisModal.hide();
        this.$bvToast && this.$bvToast.toast("Devis associé(s) avec succès.", { variant: "success", autoHideDelay: 3000 });
        await this.loadDossierDocument();
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(String(err.message || err), { variant: "danger", autoHideDelay: 5000 });
      } finally {
        this.associateDevisModal.saving = false;
      }
    },
    goToCreateFacture() {
      const query = {};
      const clientId = this.dossierDetail?.client_id || this.dossierDetail?.client?.id;
      if (clientId) query.clientId = clientId;
      if (this.dossierId) query.dossierId = this.dossierId;
      this.$router.push({ path: "/facture/factureTypes", query });
    },
    async goToFactureExistant() {
      this.resetAssociateFactureModal();
      this.$refs.associateFactureModal && this.$refs.associateFactureModal.show();
      await this.loadFactureForAssociation();
    },
    resetAssociateFactureModal() {
      this.associateFactureModal.list = [];
      this.associateFactureModal.selected = [];
      this.associateFactureModal.search = "";
      this.associateFactureModal.loading = false;
      this.associateFactureModal.saving = false;
    },
    async loadFactureForAssociation() {
      const clientId = this.dossierDetail?.client_id || this.dossierDetail?.client?.id;
      if (!clientId) {
        this.associateFactureModal.list = [];
        return;
      }
      const entrepriseId =
        this.dossierDetail?.entreprise_id ||
        this.dossierDetail?.entreprise?.id ||
        this.dossierDetail?.client?.entreprise_id ||
        this.getOnlineUser?.entreprise?.id;
      this.associateFactureModal.loading = true;
      try {
        // Récupérer les factures via API devis avec type=facture (ocrdossier_id = null)
        const response = await this.$store.dispatch("devis", {
          page: 1,
          per_page: 1000,
          client: clientId,
          ocrdossier_id: "null",
          entreprise: entrepriseId ? { id: entrepriseId } : null,
          type: "facture",
        });
        const raw = response?.data?.data ?? response?.data;
        const allFactures = Array.isArray(raw) ? raw : (raw?.data ?? []);
        // Filtrer ceux qui ont un numerofacture (dans devis ou à la racine)
        this.associateFactureModal.list = allFactures.filter((f) => f.devis?.numerofacture || f.numerofacture);
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(String(err.message || err), { variant: "danger", autoHideDelay: 4000 });
        this.associateFactureModal.list = [];
      } finally {
        this.associateFactureModal.loading = false;
      }
    },
    toggleSelectAllAssociateFacture(checked) {
      if (checked) {
        this.associateFactureModal.selected = this.filteredAssociateFactureList.map((f) => this.getDevisId(f));
      } else {
        this.associateFactureModal.selected = [];
      }
    },
    toggleAssociateFactureSelection(id) {
      const idx = this.associateFactureModal.selected.indexOf(id);
      if (idx === -1) {
        this.associateFactureModal.selected.push(id);
      } else {
        this.associateFactureModal.selected.splice(idx, 1);
      }
    },
    async submitAssociateFacture() {
      if (!this.associateFactureModal.selected.length) return;
      this.associateFactureModal.saving = true;
      try {
        await this.associate_documents({
          ocrdossierId: this.dossierId,
          devis_ids: this.associateFactureModal.selected,
        });
        this.$refs.associateFactureModal && this.$refs.associateFactureModal.hide();
        this.$bvToast && this.$bvToast.toast("Facture(s) associée(s) avec succès.", { variant: "success", autoHideDelay: 3000 });
        await this.loadDossierDocument();
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(String(err.message || err), { variant: "danger", autoHideDelay: 5000 });
      } finally {
        this.associateFactureModal.saving = false;
      }
    },
    resetAssociateCEEModal() {
      this.associateCEEModal.list = [];
      this.associateCEEModal.selected = [];
      this.associateCEEModal.search = "";
      this.associateCEEModal.loading = false;
      this.associateCEEModal.saving = false;
    },
    async loadCEEForAssociation() {
      const clientId = this.dossierDetail?.client_id || this.dossierDetail?.client?.id;
      const entrepriseId =
        this.dossierDetail?.entreprise_id ||
        this.dossierDetail?.entreprise?.id ||
        this.dossierDetail?.client?.entreprise_id ||
        this.getOnlineUser?.entreprise?.id;
      this.associateCEEModal.loading = true;
      try {
        const response = await this.allCEE({
          page: 1,
          per_page: 1000,
          client_id: clientId,
          entreprise_id: entrepriseId,
          ocrdossier_id: "null",
        });
        const raw = response?.data ?? response;
        const data = raw?.data ?? raw;
        let allCEE = Array.isArray(data) ? data : (data?.data ?? []);
        const existingCEEIds = (this.dossierDocument?.cee || []).map((c) => c.id);
        this.associateCEEModal.list = allCEE.filter((c) => c && !existingCEEIds.includes(c.id));
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(String(err.message || err), { variant: "danger", autoHideDelay: 4000 });
        this.associateCEEModal.list = [];
      } finally {
        this.associateCEEModal.loading = false;
      }
    },
    toggleSelectAllAssociateCEE(checked) {
      if (checked) {
        this.associateCEEModal.selected = this.filteredAssociateCEEList.map((c) => c.id);
      } else {
        this.associateCEEModal.selected = [];
      }
    },
    toggleAssociateCEESelection(id) {
      const idx = this.associateCEEModal.selected.indexOf(id);
      if (idx === -1) {
        this.associateCEEModal.selected.push(id);
      } else {
        this.associateCEEModal.selected.splice(idx, 1);
      }
    },
    async submitAssociateCEE() {
      if (!this.associateCEEModal.selected.length) return;
      this.associateCEEModal.saving = true;
      try {
        await this.associate_documents({
          ocrdossierId: this.dossierId,
          cee_ids: this.associateCEEModal.selected,
        });
        this.$refs.associateCEEModal && this.$refs.associateCEEModal.hide();
        this.$bvToast && this.$bvToast.toast("CC associé(s) avec succès.", { variant: "success", autoHideDelay: 3000 });
        await this.loadDossierDocument();
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(String(err.message || err), { variant: "danger", autoHideDelay: 5000 });
      } finally {
        this.associateCEEModal.saving = false;
      }
    },
    goToCreateCEE() {
      const query = {};
      const clientId = this.dossierDetail?.client_id || this.dossierDetail?.client?.id;
      if (clientId) query.clientId = clientId;
      if (this.dossierId) query.dossierId = this.dossierId;
      this.$router.push({ path: "/CEE/create", query });
    },
    goToCreateAH() {
      const query = {};
      const clientId = this.dossierDetail?.client_id || this.dossierDetail?.client?.id;
      if (clientId) query.clientId = clientId;
      if (this.dossierId) query.dossierId = this.dossierId;
      this.$router.push({ path: "/AH/create", query });
    },
    async goToCEEExistant() {
      this.resetAssociateCEEModal();
      this.$refs.associateCEEModal && this.$refs.associateCEEModal.show();
      await this.loadCEEForAssociation();
    },
    async goToAHExistant() {
      this.resetAssociateAHModal();
      this.$refs.associateAHModal && this.$refs.associateAHModal.show();
      await this.loadAHForAssociation();
    },
    resetAssociateAHModal() {
      this.associateAHModal.list = [];
      this.associateAHModal.selected = [];
      this.associateAHModal.search = "";
      this.associateAHModal.loading = false;
      this.associateAHModal.saving = false;
    },
    async loadAHForAssociation() {
      const clientId = this.dossierDetail?.client_id || this.dossierDetail?.client?.id;
      const entrepriseId =
        this.dossierDetail?.entreprise_id ||
        this.dossierDetail?.entreprise?.id ||
        this.dossierDetail?.client?.entreprise_id ||
        this.getOnlineUser?.entreprise?.id;
      this.associateAHModal.loading = true;
      try {
        const response = await this.allAH({
          page: 1,
          per_page: 1000,
          client_id: clientId,
          entreprise_id: entrepriseId,
          ocrdossier_id: "null",
        });
        const raw = response?.data ?? response;
        const data = raw?.data ?? raw;
        let allAH = Array.isArray(data) ? data : (data?.data ?? []);
        const existingAHIds = (this.dossierDocument?.ah || []).map((a) => a.id);
        this.associateAHModal.list = allAH.filter((a) => a && !existingAHIds.includes(a.id));
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(String(err.message || err), { variant: "danger", autoHideDelay: 4000 });
        this.associateAHModal.list = [];
      } finally {
        this.associateAHModal.loading = false;
      }
    },
    toggleSelectAllAssociateAH(checked) {
      if (checked) {
        this.associateAHModal.selected = this.filteredAssociateAHList.map((a) => a.id);
      } else {
        this.associateAHModal.selected = [];
      }
    },
    toggleAssociateAHSelection(id) {
      const idx = this.associateAHModal.selected.indexOf(id);
      if (idx === -1) {
        this.associateAHModal.selected.push(id);
      } else {
        this.associateAHModal.selected.splice(idx, 1);
      }
    },
    async submitAssociateAH() {
      if (!this.associateAHModal.selected.length) return;
      this.associateAHModal.saving = true;
      try {
        await this.associate_documents({
          ocrdossierId: this.dossierId,
          ah_ids: this.associateAHModal.selected,
        });
        this.$refs.associateAHModal && this.$refs.associateAHModal.hide();
        this.$bvToast && this.$bvToast.toast("AH associé(s) avec succès.", { variant: "success", autoHideDelay: 3000 });
        await this.loadDossierDocument();
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(String(err.message || err), { variant: "danger", autoHideDelay: 5000 });
      } finally {
        this.associateAHModal.saving = false;
      }
    },
    async loadComments() {
      if (!this.dossierId) return;
      this.commentsLoading = true;
      try {
        const list = await this.index_commentaires(this.dossierId);
        this.comments = Array.isArray(list) ? list : [];
      } catch (err) {
        this.comments = [];
      } finally {
        this.commentsLoading = false;
      }
    },
    async addComment() {
      const content = (this.commentText || "").trim();
      if (!content || content.replace(/<[^>]*>/g, "").trim() === "") return;
      this.commentSaving = true;
      try {
        const nomUtilisateur = this.getConnectedUserName();
        const created = await this.store_commentaire({
          ocrdossierId: this.dossierId,
          body: {
            contenu: this.commentText,
            nom_utilisateur: nomUtilisateur,
          },
        });
        if (created) {
          this.comments.push(created);
          this.commentText = "";
        }
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", { variant: "danger", autoHideDelay: 4000 });
      } finally {
        this.commentSaving = false;
      }
    },
    startEditComment(comment) {
      if (!comment || !comment.id) return;
      this.commentEditingId = comment.id;
      this.commentEditText = comment.contenu || comment.content || "";
    },
    cancelEditComment() {
      this.commentEditingId = null;
      this.commentEditText = "";
    },
    async saveEditComment() {
      if (!this.commentEditingId) return;
      const content = (this.commentEditText || "").trim();
      if (!content || content.replace(/<[^>]*>/g, "").trim() === "") return;
      this.commentEditSaving = true;
      try {
        const updated = await this.update_commentaire({
          ocrdossierId: this.dossierId,
          commentaireId: this.commentEditingId,
          body: { contenu: this.commentEditText },
        });
        const index = this.comments.findIndex((c) => c.id === this.commentEditingId);
        if (index !== -1) {
          const next = updated || {};
          this.$set(this.comments, index, {
            ...this.comments[index],
            ...next,
            contenu: next.contenu ?? next.content ?? this.commentEditText,
          });
        }
        this.cancelEditComment();
      } catch (err) {
        this.$bvToast &&
          this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", {
            variant: "danger",
            autoHideDelay: 4000,
          });
      } finally {
        this.commentEditSaving = false;
      }
    },
    async removeComment(comment) {
      if (!comment || !comment.id) return;
      const ok = await this.$bvModal?.msgBoxConfirm(this.$t("DELETE_ACCOUNT_MESSAGE") || "Supprimer ce commentaire ?", {
        title: this.$t("CONFIRM") || "Confirmer",
        size: "sm",
        okVariant: "danger",
        cancelVariant: "secondary",
      }).catch(() => false);
      if (!ok) return;
      this.commentSaving = true;
      try {
        await this.destroy_commentaire({
          ocrdossierId: this.dossierId,
          commentaireId: comment.id,
        });
        this.comments = this.comments.filter((c) => c.id !== comment.id);
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", { variant: "danger", autoHideDelay: 4000 });
      } finally {
        this.commentSaving = false;
      }
    },
    formatCommentDate(isoDate) {
      if (!isoDate) return "";
      return this.moment(isoDate).format("DD/MM/YYYY HH:mm");
    },
    getCommentAuthor(comment) {
      if (!comment) return "-";
      const user = comment.utilisateur || comment.user || comment.author || comment.created_by || null;
      const fullName = [
        user?.prenom || user?.first_name,
        user?.nom || user?.last_name,
      ]
        .filter(Boolean)
        .join(" ")
        .trim();
      return (
        comment.nom_utilisateur ||
        comment.username ||
        comment.user_name ||
        comment.nom_user ||
        comment.created_by_name ||
        user?.name ||
        fullName ||
        "-"
      );
    },
    getConnectedUserName() {
      const user = this.getOnlineUser || {};
      const fullName = [
        user.prenom || user.first_name,
        user.nom || user.last_name,
      ]
        .filter(Boolean)
        .join(" ")
        .trim();
      return user.name || user.username || fullName || "Utilisateur";
    },
    formatDocumentDate(isoDate) {
      if (!isoDate) return "-";
      return this.moment(isoDate).format("DD/MM/YYYY");
    },
    toggleDocumentSelection(index) {
      const idx = this.selectedDocumentIndices.indexOf(index);
      if (idx === -1) this.selectedDocumentIndices.push(index);
      else this.selectedDocumentIndices.splice(idx, 1);
    },
    toggleSelectAllDocuments(checked) {
      this.selectedDocumentIndices = checked ? this.documentRows.map((_, i) => i) : [];
    },
    toggleSelectAllFilteredDocuments(checked) {
      const filteredIndices = this.filteredDocumentRows.map((item) => item.index);
      if (checked) {
        const set = new Set([...this.selectedDocumentIndices, ...filteredIndices]);
        this.selectedDocumentIndices = [...set];
      } else {
        const set = new Set(filteredIndices);
        this.selectedDocumentIndices = this.selectedDocumentIndices.filter((i) => !set.has(i));
      }
    },
    async loadPhotos(filters = {}) {
      if (!this.dossierId) return;
      this.photosLoading = true;
      try {
        // Construire les paramètres de filtre dynamiques
        const params = {
          page: filters.page || 1,
          per_page: filters.per_page || 1000,
        };
        
        // Ajouter la recherche si fournie
        if (filters.search && filters.search.trim()) {
          params.search = filters.search.trim();
        }
        
        // Ajouter le filtre par catégorie (gallery_id) si fourni
        if (filters.gallery_id) {
          params.gallery_id = filters.gallery_id;
        }
        
        // Ajouter le filtre par statut si fourni
        if (filters.status) {
          params.status = filters.status;
        }
        
        const list = await this.index_photos({
          ocrdossierId: this.dossierId,
          params: params
        });
        this.photos = Array.isArray(list) ? list : [];
        this.selectedPhotoIds = [];
      } catch (err) {
        this.photos = [];
        this.selectedPhotoIds = [];
        this.$bvToast && this.$bvToast.toast(
          err && (err.message || err) ? String(err) : this.$t("ERROR_LOAD_PHOTOS") || "Erreur lors du chargement des photos",
          { variant: "danger", autoHideDelay: 4000 }
        );
      } finally {
        this.photosLoading = false;
      }
    },
    openPhotoModal() {
      this.resetPhotoModal();
      this.$refs.photoModal && this.$refs.photoModal.show();
    },
    resetPhotoModal() {
      this.photoModal.name = "";
      this.photoModal.file = null;
      this.photoModal.status = "en_attente";
      this.photoModal.gallery = null;
    },
    openImportPhotoModal() {
      this.resetImportPhotoModal();
      this.$refs.importPhotoModal && this.$refs.importPhotoModal.show();
    },
    openImportDocumentModal() {
      this.resetImportDocumentModal();
      this.$refs.importDocumentModal && this.$refs.importDocumentModal.show();
    },
    resetImportDocumentModal() {
      this.importComplementairesFiles = null;
      this.importComplementairesCategory = null;
      this.documentImportSaving = false;
    },
    async submitImportComplementaires() {
      const documentId = this.dossierDocument?.id;
      if (!documentId || !this.hasImportComplementairesFiles) return;
      const files = Array.isArray(this.importComplementairesFiles)
        ? this.importComplementairesFiles
        : this.importComplementairesFiles
        ? [this.importComplementairesFiles]
        : [];
      if (!files.length) return;
      this.documentImportSaving = true;
      try {
        this.$bvToast &&
          this.$bvToast.toast(this.$t("IMPORT") || "Import en cours...", { variant: "info", autoHideDelay: 2000 });
        
        const formData = new FormData();
        files.forEach(file => formData.append('pdf[]', file));
        
        // Ajouter category_id si une catégorie est sélectionnée
        if (this.importComplementairesCategory && this.importComplementairesCategory.id) {
          formData.append('category_id', this.importComplementairesCategory.id);
        }
        
        await this.import_document_documents({
          documentId,
          formData,
        });
        this.$refs.importDocumentModal.hide();
        this.resetImportDocumentModal();
        await this.loadDossierDocument();
        this.$bvToast &&
          this.$bvToast.toast(this.$t("IMPORT_SUCCESS") || "Import réussi.", { variant: "success", autoHideDelay: 3000 });
      } catch (err) {
        this.$bvToast &&
          this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", {
            variant: "danger",
            autoHideDelay: 5000,
          });
      } finally {
        this.documentImportSaving = false;
      }
    },
    resetImportPhotoModal() {
      this.importPhotoMode = "images";
      this.importPhotoFiles = null;
      this.importPhotoArchive = null;
    },
    async submitImportPhotos() {
      const formData = new FormData();
      if (this.importPhotoMode === "images") {
        const files = Array.isArray(this.importPhotoFiles) ? this.importPhotoFiles : (this.importPhotoFiles ? [this.importPhotoFiles] : []);
        if (!files.length) return;
        files.forEach((file) => formData.append("images[]", file));
      } else {
        if (!this.importPhotoArchive) return;
        formData.append("archive", this.importPhotoArchive);
      }
      this.photoImportSaving = true;
      try {
        await this.import_photos({
          ocrdossierId: this.dossierId,
          formData,
        });
        this.$refs.importPhotoModal && this.$refs.importPhotoModal.hide();
        await this.loadPhotos();
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", { variant: "danger", autoHideDelay: 4000 });
      } finally {
        this.photoImportSaving = false;
      }
    },
    async savePhoto() {
      if (!this.photoModal.file || !(this.photoModal.name || "").trim()) return;
      const formData = new FormData();
      formData.append("image", this.photoModal.file);
      formData.append("name", this.photoModal.name.trim());
      formData.append("status", this.photoModal.status);
      if (this.photoModal.gallery && this.photoModal.gallery.id) {
        formData.append("gallery_id", this.photoModal.gallery.id);
      }
      this.photoSaving = true;
      try {
        await this.store_photo({
          ocrdossierId: this.dossierId,
          formData,
        });
        this.$refs.photoModal && this.$refs.photoModal.hide();
        await this.loadPhotos();
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", { variant: "danger", autoHideDelay: 4000 });
      } finally {
        this.photoSaving = false;
      }
    },
    getPhotoSrc(photo) {
      return photo.image;
    },
    openPhotoViewModal(photo) {
      this.photoViewModal.photo = photo;
      this.photoViewModal.show = true;
    },
    closePhotoModal() {
      this.photoViewModal.show = false;
      this.photoViewModal.photo = null;
    },
    getPhotoStatusClass(status) {
      const statusMap = {
        'en_attente': 'badge-warning',
        'en_cours': 'badge-info', 
        'a_verifier': 'badge-secondary',
        'verifie': 'badge-success'
      };
      return statusMap[status] || 'badge-secondary';
    },
    getPhotoStatusText(status) {
      const statusTexts = {
        'en_attente': 'En attente',
        'en_cours': 'En cours',
        'a_verifier': 'À vérifier', 
        'verifie': 'Vérifié'
      };
      return statusTexts[status] || status;
    },
    limitText(count) {
      return `et ${count} autres catégories`;
    },
    onPhotoFilterChange() {
      // Mettre à jour les filtres et recharger les photos
      this.photoFilters.search = this.photoFilterName || "";
      this.photoFilters.status = this.photoFilterStatus || "";
      this.photoFilters.gallery_id = this.photoFilterGallery ? this.photoFilterGallery.id : null;
      
      // Réinitialiser la pagination
      this.photoFilters.page = 1;
      
      // Recharger les photos avec les nouveaux filtres
      this.loadPhotos(this.photoFilters);
    },
    resetPhotoFilters() {
      // Réinitialiser tous les filtres
      this.photoFilterName = "";
      this.photoFilterStatus = "";
      this.photoFilterGallery = null;
      
      this.photoFilters = {
        search: "",
        status: "",
        gallery_id: null,
        page: 1,
        per_page: 1000
      };
      
      // Recharger les photos sans filtres
      this.loadPhotos();
    },
    getPipelineBadgeClass(pipeline) {
      // Classes de couleur pour les pipelines selon leur nom ou ID
      const pipelineColors = {
        // Noms de pipelines communs
        'commercial': 'pipeline-commercial',
        'technique': 'pipeline-technique',
        'administratif': 'pipeline-administratif',
        'installation': 'pipeline-installation',
        'controle': 'pipeline-controle',
        'facturation': 'pipeline-facturation',
        // Classes par défaut basées sur l'ID si disponible
      };
      
      // Utiliser le nom ou l'ID pour déterminer la classe
      const pipelineKey = (pipeline.name || pipeline.label || '').toLowerCase();
      const pipelineId = pipeline.id ? pipeline.id.toString() : '';
      
      // Chercher une correspondance par nom
      if (pipelineColors[pipelineKey]) {
        return pipelineColors[pipelineKey];
      }
      
      // Classes par défaut basées sur l'ID (hash)
      if (pipelineId) {
        const hash = pipelineId.split('').reduce((a, b) => {
          a = ((a << 5) - a) + b.charCodeAt(0);
          return a & a;
        }, 0);
        const colorIndex = Math.abs(hash) % 6;
        const defaultColors = ['pipeline-blue', 'pipeline-green', 'pipeline-orange', 'pipeline-purple', 'pipeline-red', 'pipeline-teal'];
        return defaultColors[colorIndex];
      }
      
      return 'pipeline-default';
    },
    getSousPipelineBadgeClass(sousPipeline) {
      // Classes de couleur pour les sous-pipelines (plus claires que les pipelines)
      const sousPipelineColors = {
        // Noms de sous-pipelines communs
        'prise_contact': 'sous-pipeline-contact',
        'visite_technique': 'sous-pipeline-visite',
        'devis': 'sous-pipeline-devis',
        'signature': 'sous-pipeline-signature',
        'planification': 'sous-pipeline-planification',
        'realisation': 'sous-pipeline-realisation',
        'verification': 'sous-pipeline-verification',
        'livraison': 'sous-pipeline-livraison',
      };
      
      // Utiliser le nom ou l'ID pour déterminer la classe
      const sousPipelineKey = (sousPipeline.name || sousPipeline.label || '').toLowerCase();
      const sousPipelineId = sousPipeline.id ? sousPipeline.id.toString() : '';
      
      // Chercher une correspondance par nom
      if (sousPipelineColors[sousPipelineKey]) {
        return sousPipelineColors[sousPipelineKey];
      }
      
      // Classes par défaut basées sur l'ID (hash)
      if (sousPipelineId) {
        const hash = sousPipelineId.split('').reduce((a, b) => {
          a = ((a << 5) - a) + b.charCodeAt(0);
          return a & a;
        }, 0);
        const colorIndex = Math.abs(hash) % 6;
        const defaultColors = ['sous-pipeline-blue', 'sous-pipeline-green', 'sous-pipeline-orange', 'sous-pipeline-purple', 'sous-pipeline-red', 'sous-pipeline-teal'];
        return defaultColors[colorIndex];
      }
      
      return 'sous-pipeline-default';
    },
    togglePhotoSelection(photoId) {
      const idx = this.selectedPhotoIds.indexOf(photoId);
      if (idx === -1) this.selectedPhotoIds.push(photoId);
      else this.selectedPhotoIds.splice(idx, 1);
    },
    toggleSelectAllPhotos(checked) {
      this.selectedPhotoIds = checked ? this.photos.map((p) => p.id).filter(Boolean) : [];
    },
    exportSinglePhoto(photo) {
      if (!photo || !photo.id) return;
      this.exportPhotosByIds([photo.id], photo.name || "photo");
    },
    async exportPhotos() {
      const ids = this.selectedPhotoIds.length
        ? this.selectedPhotoIds.filter((id) => this.photos.some((p) => p.id === id))
        : this.photos.map((p) => p.id).filter(Boolean);
      const filename = ids.length ? `photos_export_${this.dossierId}.zip` : "photos_export.zip";
      await this.exportPhotosByIds(ids.length ? ids : null, filename);
    },
    async exportPhotosByIds(photoIds, defaultFilename) {
      try {
        const result = await this.export_photos({
          ocrdossierId: this.dossierId,
          photoIds: photoIds || [],
        });
        if (!result || !result.blob) return;
        const blob = result.blob;
        let filename = defaultFilename || "photos_export.zip";
        const disposition = result.headers && result.headers["content-disposition"];
        if (disposition) {
          const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i) || disposition.match(/filename=["']?([^"';]+)["']?/i);
          if (match && match[1]) filename = match[1].trim();
        }
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", { variant: "danger", autoHideDelay: 4000 });
      }
    },
    async removePhoto(photo) {
      if (!photo || !photo.id) return;
      const ok = await this.$bvModal?.msgBoxConfirm(this.$t("DELETE_ACCOUNT_MESSAGE") || "Supprimer cette photo ?", {
        title: this.$t("CONFIRM") || "Confirmer",
        size: "sm",
        okVariant: "danger",
        cancelVariant: "secondary",
      }).catch(() => false);
      if (!ok) return;
      try {
        await this.destroy_photo({
          ocrdossierId: this.dossierId,
          photoId: photo.id,
        });
        this.photos = this.photos.filter((p) => p.id !== photo.id);
        this.selectedPhotoIds = this.selectedPhotoIds.filter((id) => id !== photo.id);
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", { variant: "danger", autoHideDelay: 4000 });
      }
    },
    async updatePhotoStatus(photo, newStatus) {
      if (!photo || !photo.id) return;
      try {
        await this.update_photo({
          ocrdossierId: this.dossierId,
          photoId: photo.id,
          body: { status: newStatus },
        });
        // Update locally
        const idx = this.photos.findIndex((p) => p.id === photo.id);
        if (idx !== -1) {
          this.$set(this.photos[idx], "status", newStatus);
        }
      } catch (err) {
        this.$bvToast && this.$bvToast.toast(err && (err.message || err) ? String(err) : this.$t("ERROR") || "Erreur", { variant: "danger", autoHideDelay: 4000 });
        // Reload photos to revert
        await this.loadPhotos();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-back-dossier {
  background-color: #28367a !important;
  color: white !important;
  border-color: #28367a !important;
}
.btn-back-dossier:hover {
  background-color: #1e2a5c !important;
  color: white !important;
  border-color: #1e2a5c !important;
}

.inner-container .content {
  margin: 10px 15px;
  background-color: #fff;
  box-shadow: 1px 1px 24px #00000019;
}

.modal-test {
  width: 95%;
  margin: auto;
}

.dossier-name-numero {
  padding: 8px 12px 12px;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 12px;
  strong {
    color: #28367a;
    font-size: 1rem;
  }
  .numero-dossier,
  .dossier-date {
    color: #6c757d;
    font-size: 0.9rem;
  }
}

.cours {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  p {
    margin: 0;
    color: #fff;
    background-color: #d0cccc;
    width: fit-content;
    padding: 4px;
    height: 24px;
    font-size: 13px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.divborder {
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  color: #28367a;
  width: 100%;
  p {
    margin: 0px 10px;
  }
}
.divborder::after,
.divborder::before {
  content: "";
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  height: 1px;
  background-color: #d8d8d8;
}

.part.justify {
  margin-bottom: 1rem;
}

.info-client-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.info-client-col {
  flex: 1 1 320px;
  min-width: 280px;
}

.info-card {
  background: #fff;
  border: 1px solid #e7e7e7;
  border-radius: 10px;
  padding: 12px 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.info-card .divborder {
  margin-bottom: 10px;
}

.commentaire-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.commentaire-col {
  flex: 1 1 320px;
  min-width: 280px;
}

.commentaire-actions {
  display: flex;
  gap: 6px;
}

.commentaire-edit-wrap {
  margin-top: 8px;
}

::v-deep .nav-tabs {
  border-bottom: none;
}

::v-deep .tab-content {
  border-top: none;
}

.left {
  ul {
    list-style: none;
    padding-left: 0;
  }
  h2 {
    color: #28367a;
    font-weight: 700;
    margin-bottom: 0px;
  }
  .title {
    color: #28367a;
    font-weight: 700;
  }
}

.w-100 {
  background-color: #f8f8f8;
  padding: 4px;
  overflow-x: auto;
}

.status-chip {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.chip-default {
  background: #e9ecef;
  color: #495057;
}
.chip-en-cours {
  background: #cfe2ff;
  color: #084298;
}
.chip-non-signe {
  background: #e2e3e5;
  color: #41464b;
}
.chip-signe {
  background: #d1e7dd;
  color: #0f5132;
}
.chip-pose-en-cours {
  background: #cff4fc;
  color: #055160;
}
.chip-pose-termine {
  background: #d3f9d8;
  color: #2b8a3e;
}
.chip-controle {
  background: #fff3cd;
  color: #664d03;
}
.chip-traitement-admin {
  background: #e2d9f3;
  color: #432874;
}
.chip-a-deposer {
  background: #ffe5d0;
  color: #9c3d0e;
}
.chip-depose {
  background: #c8d6fa;
  color: #1d3a8a;
}
.chip-paye {
  background: #b2f2bb;
  color: #0d6832;
}

.grey .download-icon {
  cursor: pointer;
  color: #28367a;
}
.grey .download-icon:hover {
  opacity: 0.8;
}

.empty-tab {
  text-align: center;
  padding: 3rem 1rem;
  color: #6c757d;
  p {
    margin: 0;
  }
}
.empty-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.commentaire-tab {
  padding: 0 0 1rem;
}
.commentaire-editor-wrap {
  margin-bottom: 1rem;
  .commentaire-editor {
    min-height: 120px;
  }
}
.commentaire-list {
  margin-top: 1rem;
}
.commentaire-item {
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 12px;
  background: #f8f9fa;
}
.commentaire-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.commentaire-date {
  font-size: 0.85rem;
  color: #6c757d;
}
.commentaire-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.commentaire-author {
  font-size: 0.9rem;
  font-weight: 600;
  color: #28367a;
}
.commentaire-delete {
  padding: 0.2rem 0.4rem;
}
.commentaire-content {
  font-size: 0.95rem;
  line-height: 1.5;
  color: #333;
  padding: 0;
  border: none;
  background: transparent;
}
.commentaire-content.ql-editor {
  min-height: auto;
}

/* Photo tab */
.photo-tab {
  padding: 0 0 1rem;
}
.photo-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  gap: 12px;
}
.photo-toolbar-buttons {
  display: flex;
  gap: 8px;
}
.photo-view-toggle {
  display: flex;
  align-items: center;
}
.photo-content {
  margin-top: 0.5rem;
}
.photo-table-wrap {
  margin-top: 0;
}
.photo-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}
.photo-table th,
.photo-table td {
  padding: 10px 12px;
  border: 1px solid #dee2e6;
  vertical-align: middle;
}
.photo-table th {
  background: #f8f9fa;
  color: #28367a;
  font-weight: 600;
}
.photo-thumb-cell {
  width: 80px;
}
.photo-thumb {
  max-width: 64px;
  max-height: 64px;
  object-fit: cover;
  border-radius: 4px;
  display: block;
}
.photo-actions {
  white-space: nowrap;
}
.photo-empty-row {
  font-style: italic;
}
.doc-table-wrap {
  margin-top: 0;
}
.doc-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}
.associate-modal-table {
  max-height: 280px;
  overflow-y: auto;
}
.doc-table th,
.doc-table td {
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  vertical-align: middle;
}
.doc-check-cell {
  vertical-align: middle;
}
.document-filters .doc-filter-search,
.document-filters .doc-filter-select {
  vertical-align: middle;
}
.document-create-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.document-create-buttons .btn {
  margin: 2px 0;
}
.photo-grid-wrap {
  min-height: 120px;
}
.photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 16px;
}
.photo-grid-card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.photo-grid-card-selected {
  border-color: var(--primary, #007bff);
  box-shadow: 0 0 0 1px var(--primary, #007bff);
}
.photo-grid-check {
  padding: 6px 10px;
  border-bottom: 1px solid #eee;
}
.photo-check-cell {
  vertical-align: middle;
}
.photo-grid-thumb {
  width: 100%;
  aspect-ratio: 1;
  overflow: hidden;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.photo-grid-info {
  padding: 8px;
  font-size: 12px;
  line-height: 1.3;
}

/* Styles pour les badges de pipeline */
.pipeline-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.pipeline-badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: transform 0.2s ease;
}

.pipeline-badge:hover {
  transform: translateY(-1px);
}

.sous-pipeline-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.sous-pipeline-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 500;
  color: white;
  text-transform: capitalize;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  transition: transform 0.2s ease;
}

.sous-pipeline-badge:hover {
  transform: translateY(-1px);
}

/* Badges inline pour la liste */
.pipeline-badges-inline, .sous-pipeline-badges-inline {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-left: 8px;
}

.pipeline-badge-small, .sous-pipeline-badge-small {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  color: white;
  text-transform: capitalize;
}

/* Couleurs pour les pipelines */
.pipeline-commercial { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
.pipeline-technique { background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); }
.pipeline-administratif { background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); }
.pipeline-installation { background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%); }
.pipeline-controle { background: linear-gradient(135deg, #fa709a 0%, #fee140 100%); }
.pipeline-facturation { background: linear-gradient(135deg, #30cfd0 0%, #330867 100%); }

.pipeline-blue { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
.pipeline-green { background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%); }
.pipeline-orange { background: linear-gradient(135deg, #fa709a 0%, #fee140 100%); }
.pipeline-purple { background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); }
.pipeline-red { background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%); }
.pipeline-teal { background: linear-gradient(135deg, #30cfd0 0%, #330867 100%); }
.pipeline-default { background: linear-gradient(135deg, #a8a8a8 0%, #636363 100%); }

/* Couleurs pour les sous-pipelines (plus claires) */
.sous-pipeline-contact { background: linear-gradient(135deg, #b8c6db 0%, #f5f7fa 100%); color: #333; }
.sous-pipeline-visite { background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%); color: #333; }
.sous-pipeline-devis { background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%); color: #333; }
.sous-pipeline-signature { background: linear-gradient(135deg, #d299c2 0%, #fef9d7 100%); color: #333; }
.sous-pipeline-planification { background: linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%); }
.sous-pipeline-realisation { background: linear-gradient(135deg, #c2e9fb 0%, #a1c4fd 100%); }
.sous-pipeline-verification { background: linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%); }
.sous-pipeline-livraison { background: linear-gradient(135deg, #fdcbf1 0%, #e6dee9 100%); }

.sous-pipeline-blue { background: linear-gradient(135deg, #b8c6db 0%, #f5f7fa 100%); color: #333; }
.sous-pipeline-green { background: linear-gradient(135deg, #c2e9fb 0%, #a1c4fd 100%); color: #333; }
.sous-pipeline-orange { background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%); color: #333; }
.sous-pipeline-purple { background: linear-gradient(135deg, #d299c2 0%, #fef9d7 100%); color: #333; }
.sous-pipeline-red { background: linear-gradient(135deg, #ffcbc7 0%, #ffb6b6 100%); color: #333; }
.sous-pipeline-teal { background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%); color: #333; }
.sous-pipeline-default { background: linear-gradient(135deg, #e0e0e0 0%, #bdbdbd 100%); color: #333; }

.photo-grid-info {
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.photo-grid-name {
  font-size: 0.9rem;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.photo-grid-date {
  font-size: 0.75rem;
  color: #6c757d;
}
.photo-grid-actions {
  padding: 8px 10px;
  border-top: 1px solid #eee;
  display: flex;
  gap: 6px;
}
</style>
